// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AddTagToCaseApiV1CasesCaseIdTagsTagIdPostData, AddTagToCaseApiV1CasesCaseIdTagsTagIdPostErrors, AddTagToCaseApiV1CasesCaseIdTagsTagIdPostResponses, AddTrustEntryApiV1ClientPortalTrustEntriesPostData, AddTrustEntryApiV1ClientPortalTrustEntriesPostErrors, AddTrustEntryApiV1ClientPortalTrustEntriesPostResponses, ApproveActionPlanApiV1ReportsReportIdActionPlanApprovePostData, ApproveActionPlanApiV1ReportsReportIdActionPlanApprovePostErrors, ApproveActionPlanApiV1ReportsReportIdActionPlanApprovePostResponses, ApproveExecSummaryApiV1ReportsReportIdExecSummaryApprovePostData, ApproveExecSummaryApiV1ReportsReportIdExecSummaryApprovePostErrors, ApproveExecSummaryApiV1ReportsReportIdExecSummaryApprovePostResponses, ArchiveTrustEntryApiV1ClientPortalTrustEntriesEntryIdDeleteData, ArchiveTrustEntryApiV1ClientPortalTrustEntriesEntryIdDeleteErrors, ArchiveTrustEntryApiV1ClientPortalTrustEntriesEntryIdDeleteResponses, AssessorListFindingCommentsApiV1FindingsEvidenceCardIdCommentsGetData, AssessorListFindingCommentsApiV1FindingsEvidenceCardIdCommentsGetErrors, AssessorListFindingCommentsApiV1FindingsEvidenceCardIdCommentsGetResponses, AssessorPostFindingCommentApiV1FindingsEvidenceCardIdCommentsPostData, AssessorPostFindingCommentApiV1FindingsEvidenceCardIdCommentsPostErrors, AssessorPostFindingCommentApiV1FindingsEvidenceCardIdCommentsPostResponses, CancelToolRunApiV1ToolRunsToolRunIdCancelPostData, CancelToolRunApiV1ToolRunsToolRunIdCancelPostErrors, CancelToolRunApiV1ToolRunsToolRunIdCancelPostResponses, CommissionEngagementApiV1ClientPortalCommissionPostData, CommissionEngagementApiV1ClientPortalCommissionPostErrors, CommissionEngagementApiV1ClientPortalCommissionPostResponses, ConfirmValidationApiV1ValidateConfirmMagicTokenGetData, ConfirmValidationApiV1ValidateConfirmMagicTokenGetErrors, ConfirmValidationApiV1ValidateConfirmMagicTokenGetResponses, CreateCaseApiV1CasesPostData, CreateCaseApiV1CasesPostErrors, CreateCaseApiV1CasesPostResponses, CreateCaseCostApiV1CasesCaseIdCostsPostData, CreateCaseCostApiV1CasesCaseIdCostsPostErrors, CreateCaseCostApiV1CasesCaseIdCostsPostResponses, CreateCheckoutApiV1CasesCaseIdCheckoutPostData, CreateCheckoutApiV1CasesCaseIdCheckoutPostErrors, CreateCheckoutApiV1CasesCaseIdCheckoutPostResponses, CreateEngagementCheckoutApiV1ClientPortalEngagementsCaseIdCheckoutPostData, CreateEngagementCheckoutApiV1ClientPortalEngagementsCaseIdCheckoutPostErrors, CreateEngagementCheckoutApiV1ClientPortalEngagementsCaseIdCheckoutPostResponses, CreateEvidenceCardApiV1CasesCaseIdEvidencePostData, CreateEvidenceCardApiV1CasesCaseIdEvidencePostErrors, CreateEvidenceCardApiV1CasesCaseIdEvidencePostResponses, CreateIntegrationApiV1IntegrationsPostData, CreateIntegrationApiV1IntegrationsPostErrors, CreateIntegrationApiV1IntegrationsPostResponses, CreateInvoiceApiV1CasesCaseIdInvoicesPostData, CreateInvoiceApiV1CasesCaseIdInvoicesPostErrors, CreateInvoiceApiV1CasesCaseIdInvoicesPostResponses, CreateReportApiV1CasesCaseIdReportsPostData, CreateReportApiV1CasesCaseIdReportsPostErrors, CreateReportApiV1CasesCaseIdReportsPostResponses, CreateSettingApiV1SettingsPostData, CreateSettingApiV1SettingsPostErrors, CreateSettingApiV1SettingsPostResponses, CreateShareApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesPostData, CreateShareApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesPostErrors, CreateShareApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesPostResponses, CreateTagApiV1TagsPostData, CreateTagApiV1TagsPostErrors, CreateTagApiV1TagsPostResponses, CreateTargetApiV1CasesCaseIdTargetsPostData, CreateTargetApiV1CasesCaseIdTargetsPostErrors, CreateTargetApiV1CasesCaseIdTargetsPostResponses, CreateTaskApiV1CasesCaseIdTasksPostData, CreateTaskApiV1CasesCaseIdTasksPostErrors, CreateTaskApiV1CasesCaseIdTasksPostResponses, CreateTimeSessionApiV1CasesCaseIdSessionsPostData, CreateTimeSessionApiV1CasesCaseIdSessionsPostErrors, CreateTimeSessionApiV1CasesCaseIdSessionsPostResponses, DeleteIntegrationApiV1IntegrationsNameDeleteData, DeleteIntegrationApiV1IntegrationsNameDeleteErrors, DeleteIntegrationApiV1IntegrationsNameDeleteResponses, DeleteSettingApiV1SettingsSettingIdDeleteData, DeleteSettingApiV1SettingsSettingIdDeleteErrors, DeleteSettingApiV1SettingsSettingIdDeleteResponses, DeleteTagApiV1TagsTagIdDeleteData, DeleteTagApiV1TagsTagIdDeleteErrors, DeleteTagApiV1TagsTagIdDeleteResponses, DeleteTargetApiV1TargetsTargetIdDeleteData, DeleteTargetApiV1TargetsTargetIdDeleteErrors, DeleteTargetApiV1TargetsTargetIdDeleteResponses, DeleteTaskApiV1TasksTaskIdDeleteData, DeleteTaskApiV1TasksTaskIdDeleteErrors, DeleteTaskApiV1TasksTaskIdDeleteResponses, DownloadAnonymizedReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdAnonymizedPdfGetData, DownloadAnonymizedReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdAnonymizedPdfGetErrors, DownloadAnonymizedReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdAnonymizedPdfGetResponses, DownloadAnonymizedReportPdfApiV1ReportsReportIdAnonymizedPdfGetData, DownloadAnonymizedReportPdfApiV1ReportsReportIdAnonymizedPdfGetErrors, DownloadAnonymizedReportPdfApiV1ReportsReportIdAnonymizedPdfGetResponses, DownloadAttestationPdfApiV1ReportsReportIdAttestationPdfGetData, DownloadAttestationPdfApiV1ReportsReportIdAttestationPdfGetErrors, DownloadAttestationPdfApiV1ReportsReportIdAttestationPdfGetResponses, DownloadClientReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdPdfGetData, DownloadClientReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdPdfGetErrors, DownloadClientReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdPdfGetResponses, DownloadDeliverableBundleApiV1ReportsReportIdBundleZipGetData, DownloadDeliverableBundleApiV1ReportsReportIdBundleZipGetErrors, DownloadDeliverableBundleApiV1ReportsReportIdBundleZipGetResponses, DownloadReportPdfApiV1ReportsReportIdPdfGetData, DownloadReportPdfApiV1ReportsReportIdPdfGetErrors, DownloadReportPdfApiV1ReportsReportIdPdfGetResponses, DownloadSnapshotPdfApiV1ReportsReportIdSnapshotPdfGetData, DownloadSnapshotPdfApiV1ReportsReportIdSnapshotPdfGetErrors, DownloadSnapshotPdfApiV1ReportsReportIdSnapshotPdfGetResponses, DownloadTrackingSheetCsvApiV1ReportsReportIdTrackingSheetCsvGetData, DownloadTrackingSheetCsvApiV1ReportsReportIdTrackingSheetCsvGetErrors, DownloadTrackingSheetCsvApiV1ReportsReportIdTrackingSheetCsvGetResponses, DownloadValidatedPdfApiV1ValidateGrantIdPdfGetData, DownloadValidatedPdfApiV1ValidateGrantIdPdfGetErrors, DownloadValidatedPdfApiV1ValidateGrantIdPdfGetResponses, ExecuteAllPendingStepsApiV1CasesCaseIdScanPlanExecuteAllPostData, ExecuteAllPendingStepsApiV1CasesCaseIdScanPlanExecuteAllPostErrors, ExecuteAllPendingStepsApiV1CasesCaseIdScanPlanExecuteAllPostResponses, ExecuteNextScanStepApiV1CasesCaseIdScanPlanExecuteNextPostData, ExecuteNextScanStepApiV1CasesCaseIdScanPlanExecuteNextPostErrors, ExecuteNextScanStepApiV1CasesCaseIdScanPlanExecuteNextPostResponses, ForgotPasswordApiV1ClientAuthForgotPostData, ForgotPasswordApiV1ClientAuthForgotPostErrors, ForgotPasswordApiV1ClientAuthForgotPostResponses, GenerateActionPlanApiV1ReportsReportIdActionPlanGeneratePostData, GenerateActionPlanApiV1ReportsReportIdActionPlanGeneratePostErrors, GenerateActionPlanApiV1ReportsReportIdActionPlanGeneratePostResponses, GenerateExecSummaryApiV1ReportsReportIdExecSummaryGeneratePostData, GenerateExecSummaryApiV1ReportsReportIdExecSummaryGeneratePostErrors, GenerateExecSummaryApiV1ReportsReportIdExecSummaryGeneratePostResponses, GetActionPlanApiV1ReportsReportIdActionPlanGetData, GetActionPlanApiV1ReportsReportIdActionPlanGetErrors, GetActionPlanApiV1ReportsReportIdActionPlanGetResponses, GetCaseApiV1CasesCaseIdGetData, GetCaseApiV1CasesCaseIdGetErrors, GetCaseApiV1CasesCaseIdGetResponses, GetCaseTagsApiV1CasesCaseIdTagsGetData, GetCaseTagsApiV1CasesCaseIdTagsGetErrors, GetCaseTagsApiV1CasesCaseIdTagsGetResponses, GetCaseTimelineApiV1CasesCaseIdTimelineGetData, GetCaseTimelineApiV1CasesCaseIdTimelineGetErrors, GetCaseTimelineApiV1CasesCaseIdTimelineGetResponses, GetCurrentAttestationApiV1AttestationCurrentGetData, GetCurrentAttestationApiV1AttestationCurrentGetResponses, GetDashboardPulseApiV1ClientPortalPulseGetData, GetDashboardPulseApiV1ClientPortalPulseGetErrors, GetDashboardPulseApiV1ClientPortalPulseGetResponses, GetDashboardStatsApiV1DashboardStatsGetData, GetDashboardStatsApiV1DashboardStatsGetResponses, GetEngagementActivityApiV1ClientPortalEngagementsCaseIdActivityGetData, GetEngagementActivityApiV1ClientPortalEngagementsCaseIdActivityGetErrors, GetEngagementActivityApiV1ClientPortalEngagementsCaseIdActivityGetResponses, GetEngagementApiV1ClientPortalEngagementsCaseIdGetData, GetEngagementApiV1ClientPortalEngagementsCaseIdGetErrors, GetEngagementApiV1ClientPortalEngagementsCaseIdGetResponses, GetEvidenceCardApiV1EvidenceEvidenceIdGetData, GetEvidenceCardApiV1EvidenceEvidenceIdGetErrors, GetEvidenceCardApiV1EvidenceEvidenceIdGetResponses, GetExecSummaryApiV1ReportsReportIdExecSummaryGetData, GetExecSummaryApiV1ReportsReportIdExecSummaryGetErrors, GetExecSummaryApiV1ReportsReportIdExecSummaryGetResponses, GetFindingStateApiV1EvidenceEvidenceIdStateGetData, GetFindingStateApiV1EvidenceEvidenceIdStateGetErrors, GetFindingStateApiV1EvidenceEvidenceIdStateGetResponses, GetHealthData, GetHealthResponses, GetIntegrationApiV1IntegrationsNameGetData, GetIntegrationApiV1IntegrationsNameGetErrors, GetIntegrationApiV1IntegrationsNameGetResponses, GetInvoiceApiV1InvoicesInvoiceIdGetData, GetInvoiceApiV1InvoicesInvoiceIdGetErrors, GetInvoiceApiV1InvoicesInvoiceIdGetResponses, GetPublicStatusData, GetPublicStatusResponses, GetReportApiV1ReportsReportIdGetData, GetReportApiV1ReportsReportIdGetErrors, GetReportApiV1ReportsReportIdGetResponses, GetReportPayloadApiV1ClientPortalEngagementsCaseIdReportsReportIdPayloadGetData, GetReportPayloadApiV1ClientPortalEngagementsCaseIdReportsReportIdPayloadGetErrors, GetReportPayloadApiV1ClientPortalEngagementsCaseIdReportsReportIdPayloadGetResponses, GetScanPlanApiV1CasesCaseIdScanPlanGetData, GetScanPlanApiV1CasesCaseIdScanPlanGetErrors, GetScanPlanApiV1CasesCaseIdScanPlanGetResponses, GetScanProgressApiV1CasesCaseIdScanProgressGetData, GetScanProgressApiV1CasesCaseIdScanProgressGetErrors, GetScanProgressApiV1CasesCaseIdScanProgressGetResponses, GetToolDefaultArgsApiV1ToolsToolNameDefaultArgsGetData, GetToolDefaultArgsApiV1ToolsToolNameDefaultArgsGetErrors, GetToolDefaultArgsApiV1ToolsToolNameDefaultArgsGetResponses, GetToolRunApiV1ToolRunsToolRunIdGetData, GetToolRunApiV1ToolRunsToolRunIdGetErrors, GetToolRunApiV1ToolRunsToolRunIdGetResponses, GetToolRunRawOutputApiV1ToolRunsToolRunIdRawOutputGetData, GetToolRunRawOutputApiV1ToolRunsToolRunIdRawOutputGetErrors, GetToolRunRawOutputApiV1ToolRunsToolRunIdRawOutputGetResponses, GetValidatedPayloadApiV1ValidateGrantIdPayloadGetData, GetValidatedPayloadApiV1ValidateGrantIdPayloadGetErrors, GetValidatedPayloadApiV1ValidateGrantIdPayloadGetResponses, ListAvailableToolsApiV1ToolsAvailableGetData, ListAvailableToolsApiV1ToolsAvailableGetResponses, ListCaseCostsApiV1CasesCaseIdCostsGetData, ListCaseCostsApiV1CasesCaseIdCostsGetErrors, ListCaseCostsApiV1CasesCaseIdCostsGetResponses, ListCaseNotificationsApiV1CasesCaseIdNotificationsGetData, ListCaseNotificationsApiV1CasesCaseIdNotificationsGetErrors, ListCaseNotificationsApiV1CasesCaseIdNotificationsGetResponses, ListCasesApiV1CasesGetData, ListCasesApiV1CasesGetErrors, ListCasesApiV1CasesGetResponses, ListEngagementsApiV1ClientPortalEngagementsGetData, ListEngagementsApiV1ClientPortalEngagementsGetErrors, ListEngagementsApiV1ClientPortalEngagementsGetResponses, ListEvidenceCardsApiV1CasesCaseIdEvidenceGetData, ListEvidenceCardsApiV1CasesCaseIdEvidenceGetErrors, ListEvidenceCardsApiV1CasesCaseIdEvidenceGetResponses, ListFindingActionsApiV1ClientPortalEngagementsCaseIdFindingActionsGetData, ListFindingActionsApiV1ClientPortalEngagementsCaseIdFindingActionsGetErrors, ListFindingActionsApiV1ClientPortalEngagementsCaseIdFindingActionsGetResponses, ListFindingCommentsApiV1ClientPortalFindingsEvidenceCardIdCommentsGetData, ListFindingCommentsApiV1ClientPortalFindingsEvidenceCardIdCommentsGetErrors, ListFindingCommentsApiV1ClientPortalFindingsEvidenceCardIdCommentsGetResponses, ListIntegrationsApiV1IntegrationsGetData, ListIntegrationsApiV1IntegrationsGetResponses, ListInvoicesApiV1CasesCaseIdInvoicesGetData, ListInvoicesApiV1CasesCaseIdInvoicesGetErrors, ListInvoicesApiV1CasesCaseIdInvoicesGetResponses, ListReportsApiV1CasesCaseIdReportsGetData, ListReportsApiV1CasesCaseIdReportsGetErrors, ListReportsApiV1CasesCaseIdReportsGetResponses, ListSettingsApiV1SettingsGetData, ListSettingsApiV1SettingsGetResponses, ListShareAccessLogApiV1ClientPortalSharesGrantIdAccessLogGetData, ListShareAccessLogApiV1ClientPortalSharesGrantIdAccessLogGetErrors, ListShareAccessLogApiV1ClientPortalSharesGrantIdAccessLogGetResponses, ListSharesForReportApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesGetData, ListSharesForReportApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesGetErrors, ListSharesForReportApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesGetResponses, ListTagsApiV1TagsGetData, ListTagsApiV1TagsGetResponses, ListTargetsApiV1CasesCaseIdTargetsGetData, ListTargetsApiV1CasesCaseIdTargetsGetErrors, ListTargetsApiV1CasesCaseIdTargetsGetResponses, ListTasksApiV1CasesCaseIdTasksGetData, ListTasksApiV1CasesCaseIdTasksGetErrors, ListTasksApiV1CasesCaseIdTasksGetResponses, ListTimeSessionsApiV1CasesCaseIdSessionsGetData, ListTimeSessionsApiV1CasesCaseIdSessionsGetErrors, ListTimeSessionsApiV1CasesCaseIdSessionsGetResponses, ListToolRunsApiV1CasesCaseIdToolRunsGetData, ListToolRunsApiV1CasesCaseIdToolRunsGetErrors, ListToolRunsApiV1CasesCaseIdToolRunsGetResponses, ListTrustEntriesApiV1ClientPortalTrustEntriesGetData, ListTrustEntriesApiV1ClientPortalTrustEntriesGetErrors, ListTrustEntriesApiV1ClientPortalTrustEntriesGetResponses, LoginApiV1AuthLoginPostData, LoginApiV1AuthLoginPostErrors, LoginApiV1AuthLoginPostResponses, LoginApiV1ClientAuthLoginPostData, LoginApiV1ClientAuthLoginPostErrors, LoginApiV1ClientAuthLoginPostResponses, LogoutApiV1AuthLogoutPostData, LogoutApiV1AuthLogoutPostErrors, LogoutApiV1AuthLogoutPostResponses, LogoutApiV1ClientAuthLogoutPostData, LogoutApiV1ClientAuthLogoutPostErrors, LogoutApiV1ClientAuthLogoutPostResponses, MeApiV1ClientAuthMeGetData, MeApiV1ClientAuthMeGetErrors, MeApiV1ClientAuthMeGetResponses, OperatorAttestCaseApiV1CasesCaseIdOperatorAttestPostData, OperatorAttestCaseApiV1CasesCaseIdOperatorAttestPostErrors, OperatorAttestCaseApiV1CasesCaseIdOperatorAttestPostResponses, PostFindingCommentApiV1ClientPortalFindingsEvidenceCardIdCommentsPostData, PostFindingCommentApiV1ClientPortalFindingsEvidenceCardIdCommentsPostErrors, PostFindingCommentApiV1ClientPortalFindingsEvidenceCardIdCommentsPostResponses, PrepareDeliverablesApiV1ReportsReportIdPrepareDeliverablesPostData, PrepareDeliverablesApiV1ReportsReportIdPrepareDeliverablesPostErrors, PrepareDeliverablesApiV1ReportsReportIdPrepareDeliverablesPostResponses, PreviewAnonymizedReportApiV1ReportsReportIdAnonymizedHtmlGetData, PreviewAnonymizedReportApiV1ReportsReportIdAnonymizedHtmlGetErrors, PreviewAnonymizedReportApiV1ReportsReportIdAnonymizedHtmlGetResponses, PreviewCartPricingApiV1ClientPortalPricingPreviewPostData, PreviewCartPricingApiV1ClientPortalPricingPreviewPostErrors, PreviewCartPricingApiV1ClientPortalPricingPreviewPostResponses, PreviewReportHtmlApiV1ReportsReportIdHtmlGetData, PreviewReportHtmlApiV1ReportsReportIdHtmlGetErrors, PreviewReportHtmlApiV1ReportsReportIdHtmlGetResponses, PromoteTargetApiV1TargetsTargetIdPromotePostData, PromoteTargetApiV1TargetsTargetIdPromotePostErrors, PromoteTargetApiV1TargetsTargetIdPromotePostResponses, RecipientListFindingCommentsApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsGetData, RecipientListFindingCommentsApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsGetErrors, RecipientListFindingCommentsApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsGetResponses, RecipientPostFindingCommentApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsPostData, RecipientPostFindingCommentApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsPostErrors, RecipientPostFindingCommentApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsPostResponses, RecordFindingActionApiV1ClientPortalFindingsEvidenceCardIdActionPostData, RecordFindingActionApiV1ClientPortalFindingsEvidenceCardIdActionPostErrors, RecordFindingActionApiV1ClientPortalFindingsEvidenceCardIdActionPostResponses, RefreshApiV1ClientAuthRefreshPostData, RefreshApiV1ClientAuthRefreshPostErrors, RefreshApiV1ClientAuthRefreshPostResponses, RefreshReportPayloadApiV1ReportsReportIdRefreshPayloadPostData, RefreshReportPayloadApiV1ReportsReportIdRefreshPayloadPostErrors, RefreshReportPayloadApiV1ReportsReportIdRefreshPayloadPostResponses, RefreshTokenApiV1AuthRefreshPostData, RefreshTokenApiV1AuthRefreshPostErrors, RefreshTokenApiV1AuthRefreshPostResponses, RemoveTagFromCaseApiV1CasesCaseIdTagsTagIdDeleteData, RemoveTagFromCaseApiV1CasesCaseIdTagsTagIdDeleteErrors, RemoveTagFromCaseApiV1CasesCaseIdTagsTagIdDeleteResponses, RequestFindingVerificationApiV1ClientPortalFindingsEvidenceCardIdVerifyFixPostData, RequestFindingVerificationApiV1ClientPortalFindingsEvidenceCardIdVerifyFixPostErrors, RequestFindingVerificationApiV1ClientPortalFindingsEvidenceCardIdVerifyFixPostResponses, ResendVerifyEmailApiV1ClientAuthResendVerifyPostData, ResendVerifyEmailApiV1ClientAuthResendVerifyPostErrors, ResendVerifyEmailApiV1ClientAuthResendVerifyPostResponses, ResetCaseToolDataApiV1CasesCaseIdResetToolDataPostData, ResetCaseToolDataApiV1CasesCaseIdResetToolDataPostErrors, ResetCaseToolDataApiV1CasesCaseIdResetToolDataPostResponses, ResetPasswordApiV1ClientAuthResetResetTokenPostData, ResetPasswordApiV1ClientAuthResetResetTokenPostErrors, ResetPasswordApiV1ClientAuthResetResetTokenPostResponses, RevokeShareApiV1ClientPortalSharesGrantIdRevokePostData, RevokeShareApiV1ClientPortalSharesGrantIdRevokePostErrors, RevokeShareApiV1ClientPortalSharesGrantIdRevokePostResponses, RunPreviewApiV1DiscoveryPreviewPostData, RunPreviewApiV1DiscoveryPreviewPostErrors, RunPreviewApiV1DiscoveryPreviewPostResponses, ScanAllPendingForTargetApiV1TargetsTargetIdScanAllPendingPostData, ScanAllPendingForTargetApiV1TargetsTargetIdScanAllPendingPostErrors, ScanAllPendingForTargetApiV1TargetsTargetIdScanAllPendingPostResponses, SetFindingStateApiV1EvidenceEvidenceIdStatePostData, SetFindingStateApiV1EvidenceEvidenceIdStatePostErrors, SetFindingStateApiV1EvidenceEvidenceIdStatePostResponses, SetTargetScopeApiV1TargetsTargetIdScopePostData, SetTargetScopeApiV1TargetsTargetIdScopePostErrors, SetTargetScopeApiV1TargetsTargetIdScopePostResponses, SetupPasswordApiV1ClientAuthSetupSetupTokenPostData, SetupPasswordApiV1ClientAuthSetupSetupTokenPostErrors, SetupPasswordApiV1ClientAuthSetupSetupTokenPostResponses, SignupApiV1ClientAuthSignupPostData, SignupApiV1ClientAuthSignupPostErrors, SignupApiV1ClientAuthSignupPostResponses, StartIdentityVerificationApiV1CasesCaseIdIdentityStartPostData, StartIdentityVerificationApiV1CasesCaseIdIdentityStartPostErrors, StartIdentityVerificationApiV1CasesCaseIdIdentityStartPostResponses, StreamScanEventsApiV1CasesCaseIdScanEventsGetData, StreamScanEventsApiV1CasesCaseIdScanEventsGetErrors, StreamScanEventsApiV1CasesCaseIdScanEventsGetResponses, StripeWebhookApiV1WebhooksStripePostData, StripeWebhookApiV1WebhooksStripePostErrors, StripeWebhookApiV1WebhooksStripePostResponses, SubmitCustomInquiryApiV1IntakeInquiryPostData, SubmitCustomInquiryApiV1IntakeInquiryPostErrors, SubmitCustomInquiryApiV1IntakeInquiryPostResponses, SubmitIntakeApiV1IntakePostData, SubmitIntakeApiV1IntakePostErrors, SubmitIntakeApiV1IntakePostResponses, SubmitValidationApiV1ValidatePostData, SubmitValidationApiV1ValidatePostErrors, SubmitValidationApiV1ValidatePostResponses, SupersedeEvidenceCardApiV1EvidenceEvidenceIdSupersedePostData, SupersedeEvidenceCardApiV1EvidenceEvidenceIdSupersedePostErrors, SupersedeEvidenceCardApiV1EvidenceEvidenceIdSupersedePostResponses, TestIntegrationApiV1IntegrationsNameTestPostData, TestIntegrationApiV1IntegrationsNameTestPostErrors, TestIntegrationApiV1IntegrationsNameTestPostResponses, TransitionCaseStatusApiV1CasesCaseIdStatusPostData, TransitionCaseStatusApiV1CasesCaseIdStatusPostErrors, TransitionCaseStatusApiV1CasesCaseIdStatusPostResponses, TriggerToolRunApiV1ToolsRunPostData, TriggerToolRunApiV1ToolsRunPostErrors, TriggerToolRunApiV1ToolsRunPostResponses, UpdateActionPlanApiV1ReportsReportIdActionPlanPatchData, UpdateActionPlanApiV1ReportsReportIdActionPlanPatchErrors, UpdateActionPlanApiV1ReportsReportIdActionPlanPatchResponses, UpdateCaseApiV1CasesCaseIdPatchData, UpdateCaseApiV1CasesCaseIdPatchErrors, UpdateCaseApiV1CasesCaseIdPatchResponses, UpdateExecSummaryApiV1ReportsReportIdExecSummaryPatchData, UpdateExecSummaryApiV1ReportsReportIdExecSummaryPatchErrors, UpdateExecSummaryApiV1ReportsReportIdExecSummaryPatchResponses, UpdateIntegrationApiV1IntegrationsNamePatchData, UpdateIntegrationApiV1IntegrationsNamePatchErrors, UpdateIntegrationApiV1IntegrationsNamePatchResponses, UpdateInvoiceApiV1InvoicesInvoiceIdPatchData, UpdateInvoiceApiV1InvoicesInvoiceIdPatchErrors, UpdateInvoiceApiV1InvoicesInvoiceIdPatchResponses, UpdateReportApiV1ReportsReportIdPatchData, UpdateReportApiV1ReportsReportIdPatchErrors, UpdateReportApiV1ReportsReportIdPatchResponses, UpdateSettingApiV1SettingsSettingIdPatchData, UpdateSettingApiV1SettingsSettingIdPatchErrors, UpdateSettingApiV1SettingsSettingIdPatchResponses, UpdateTagApiV1TagsTagIdPatchData, UpdateTagApiV1TagsTagIdPatchErrors, UpdateTagApiV1TagsTagIdPatchResponses, UpdateTargetApiV1TargetsTargetIdPatchData, UpdateTargetApiV1TargetsTargetIdPatchErrors, UpdateTargetApiV1TargetsTargetIdPatchResponses, UpdateTaskApiV1TasksTaskIdPatchData, UpdateTaskApiV1TasksTaskIdPatchErrors, UpdateTaskApiV1TasksTaskIdPatchResponses, UpdateTimeSessionApiV1SessionsSessionIdPatchData, UpdateTimeSessionApiV1SessionsSessionIdPatchErrors, UpdateTimeSessionApiV1SessionsSessionIdPatchResponses, VerifyEmailApiV1ClientAuthVerifyEmailVerifyTokenPostData, VerifyEmailApiV1ClientAuthVerifyEmailVerifyTokenPostErrors, VerifyEmailApiV1ClientAuthVerifyEmailVerifyTokenPostResponses, VerifyReportVerifyCaseNumberReportIdGetData, VerifyReportVerifyCaseNumberReportIdGetErrors, VerifyReportVerifyCaseNumberReportIdGetResponses, WaivePaymentApiV1CasesCaseIdWaivePaymentPostData, WaivePaymentApiV1CasesCaseIdWaivePaymentPostErrors, WaivePaymentApiV1CasesCaseIdWaivePaymentPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Health
 *
 * Liveness probe. Returns 200 if the process is up and can read config.
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>) => (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({ url: '/health', ...options });

/**
 * Public Status
 *
 * Public health + incident-timeline endpoint for /Recon's /status page.
 *
 * No auth. Response shape is stable — empty incidents list when
 * there are no incidents (not absent key). UI can render the page
 * from a single fetch.
 */
export const getPublicStatus = <ThrowOnError extends boolean = false>(options?: Options<GetPublicStatusData, ThrowOnError>) => (options?.client ?? client).get<GetPublicStatusResponses, unknown, ThrowOnError>({ url: '/api/v1/status', ...options });

/**
 * Submit Intake
 *
 * Legacy no-payment intake.
 *
 * Creates a client, case (intake status), and targets atomically.
 * The portal commission flow at /api/v1/client-portal/commission is
 * the path for new flows; this endpoint is kept for operator-
 * driven imports / migrations that bypass payment.
 */
export const submitIntakeApiV1IntakePost = <ThrowOnError extends boolean = false>(options: Options<SubmitIntakeApiV1IntakePostData, ThrowOnError>) => (options.client ?? client).post<SubmitIntakeApiV1IntakePostResponses, SubmitIntakeApiV1IntakePostErrors, ThrowOnError>({
    url: '/api/v1/intake',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Custom Inquiry
 *
 * Custom Inquiry submission — buyer's scope doesn't fit the
 * configurator, so they're asking the operator to quote.
 *
 * Flow:
 * 1. Insert the inquiry into `intake_lead`.
 * 2. Fire-and-forget the operator notification email.
 * 3. Stamp `operator_notified_at` on success so the operator can
 * see which leads went silent vs which ones we forgot to follow
 * up on.
 * 4. Return the new `lead_id` + timestamp to the buyer for the
 * confirmation panel.
 *
 * Validation:
 * - `contact_name` and `contact_email` are required.
 * - `scope_description` has a 20-character minimum (single-word
 * "help" submissions don't give the operator anything to work
 * with).
 * - `attempted_cart` is optional — populated when the buyer
 * opened the inquiry panel from inside the configurator,
 * empty otherwise.
 *
 * Failure modes the operator should know about:
 * - DB insert succeeds, notification fails: lead is in the table
 * with `operator_notified_at = NULL`. The operator can run a
 * "show me leads we owe follow-up on" query against that
 * column.
 * - DB insert fails: 5xx returned to the buyer; they can retry.
 * No partial state because the insert is the only mutation
 * before the notification fires.
 *
 * Anonymous on purpose: a buyer who hasn't signed up should still
 * be able to ask for a quote.
 */
export const submitCustomInquiryApiV1IntakeInquiryPost = <ThrowOnError extends boolean = false>(options: Options<SubmitCustomInquiryApiV1IntakeInquiryPostData, ThrowOnError>) => (options.client ?? client).post<SubmitCustomInquiryApiV1IntakeInquiryPostResponses, SubmitCustomInquiryApiV1IntakeInquiryPostErrors, ThrowOnError>({
    url: '/api/v1/intake/inquiry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Current Attestation
 *
 * Return the currently-published attestation text + version + hash.
 */
export const getCurrentAttestationApiV1AttestationCurrentGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentAttestationApiV1AttestationCurrentGetData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentAttestationApiV1AttestationCurrentGetResponses, unknown, ThrowOnError>({ url: '/api/v1/attestation/current', ...options });

/**
 * Run Preview
 *
 * Run a passive discovery scan against the seed and return the assets.
 *
 * Authenticated via the portal cookie — only logged-in buyers can run
 * discovery. This avoids using the endpoint as a free recon proxy for
 * arbitrary third parties.
 */
export const runPreviewApiV1DiscoveryPreviewPost = <ThrowOnError extends boolean = false>(options: Options<RunPreviewApiV1DiscoveryPreviewPostData, ThrowOnError>) => (options.client ?? client).post<RunPreviewApiV1DiscoveryPreviewPostResponses, RunPreviewApiV1DiscoveryPreviewPostErrors, ThrowOnError>({
    url: '/api/v1/discovery/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Checkout
 *
 * Create a Stripe Checkout Session for a case.
 *
 * The buyer-facing /Recon flow calls
 * `/api/v1/client-portal/engagements/{case_id}/checkout` instead,
 * which scopes the case to the authenticated buyer. This endpoint
 * remains for operator-initiated payment links.
 *
 * No request body — the amount is server-derived from the case's
 * in-scope domain target count via the /Recon price bands.
 */
export const createCheckoutApiV1CasesCaseIdCheckoutPost = <ThrowOnError extends boolean = false>(options: Options<CreateCheckoutApiV1CasesCaseIdCheckoutPostData, ThrowOnError>) => (options.client ?? client).post<CreateCheckoutApiV1CasesCaseIdCheckoutPostResponses, CreateCheckoutApiV1CasesCaseIdCheckoutPostErrors, ThrowOnError>({ url: '/api/v1/cases/{case_id}/checkout', ...options });

/**
 * Waive Payment
 *
 * Investigator marks a case payment as waived (invoice-later, retainer, internal).
 */
export const waivePaymentApiV1CasesCaseIdWaivePaymentPost = <ThrowOnError extends boolean = false>(options: Options<WaivePaymentApiV1CasesCaseIdWaivePaymentPostData, ThrowOnError>) => (options.client ?? client).post<WaivePaymentApiV1CasesCaseIdWaivePaymentPostResponses, WaivePaymentApiV1CasesCaseIdWaivePaymentPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/waive-payment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Identity Verification
 *
 * Create a Stripe Identity VerificationSession for an individual case.
 *
 * Called from /Recon after the buyer signs the authorization (or
 * inline during checkout — Bucket P P5 wires the actual flow).
 * Returns the Stripe-hosted verification URL the buyer is redirected
 * to. Result comes back via webhook (identity.verification_session.*).
 *
 * No auth — the buyer is acting on their own case via a public URL,
 * not accessing private data. Same posture as POST /checkout.
 */
export const startIdentityVerificationApiV1CasesCaseIdIdentityStartPost = <ThrowOnError extends boolean = false>(options: Options<StartIdentityVerificationApiV1CasesCaseIdIdentityStartPostData, ThrowOnError>) => (options.client ?? client).post<StartIdentityVerificationApiV1CasesCaseIdIdentityStartPostResponses, StartIdentityVerificationApiV1CasesCaseIdIdentityStartPostErrors, ThrowOnError>({
    url: '/api/v1/cases/{case_id}/identity/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stripe Webhook
 *
 * Stripe webhook endpoint. No auth — signature is the auth.
 */
export const stripeWebhookApiV1WebhooksStripePost = <ThrowOnError extends boolean = false>(options: Options<StripeWebhookApiV1WebhooksStripePostData, ThrowOnError>) => (options.client ?? client).post<StripeWebhookApiV1WebhooksStripePostResponses, StripeWebhookApiV1WebhooksStripePostErrors, ThrowOnError>({ url: '/api/v1/webhooks/stripe', ...options });

/**
 * Signup
 *
 * Self-serve signup. Creates a Client + ClientCredential, mints a
 * verify-email token, sends the verify email, returns auth tokens.
 *
 * Rate-limited per-IP (5 attempts / 15 min) — bot signup floods are the
 * primary abuse vector here, not credential stuffing. Audit-logged
 * both ways so abuse patterns are queryable post-hoc.
 *
 * The user is logged in immediately even though their email is unverified.
 * Downstream gates (commission flow) check email_verified_at server-side.
 */
export const signupApiV1ClientAuthSignupPost = <ThrowOnError extends boolean = false>(options: Options<SignupApiV1ClientAuthSignupPostData, ThrowOnError>) => (options.client ?? client).post<SignupApiV1ClientAuthSignupPostResponses, SignupApiV1ClientAuthSignupPostErrors, ThrowOnError>({
    url: '/api/v1/client-auth/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Email
 *
 * Confirm an email address via the link from the welcome email.
 *
 * Single-use; the token is cleared on success. Idempotent on re-consume:
 * a second click of the same link returns 400 (token already used) but
 * the email_verified_at flag stays set on the credential.
 */
export const verifyEmailApiV1ClientAuthVerifyEmailVerifyTokenPost = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailApiV1ClientAuthVerifyEmailVerifyTokenPostData, ThrowOnError>) => (options.client ?? client).post<VerifyEmailApiV1ClientAuthVerifyEmailVerifyTokenPostResponses, VerifyEmailApiV1ClientAuthVerifyEmailVerifyTokenPostErrors, ThrowOnError>({ url: '/api/v1/client-auth/verify-email/{verify_token}', ...options });

/**
 * Setup Password
 *
 * One-time-setup: client clicks the link from their welcome email,
 * sets their password, and is logged in immediately.
 */
export const setupPasswordApiV1ClientAuthSetupSetupTokenPost = <ThrowOnError extends boolean = false>(options: Options<SetupPasswordApiV1ClientAuthSetupSetupTokenPostData, ThrowOnError>) => (options.client ?? client).post<SetupPasswordApiV1ClientAuthSetupSetupTokenPostResponses, SetupPasswordApiV1ClientAuthSetupSetupTokenPostErrors, ThrowOnError>({
    url: '/api/v1/client-auth/setup/{setup_token}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 */
export const loginApiV1ClientAuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginApiV1ClientAuthLoginPostData, ThrowOnError>) => (options.client ?? client).post<LoginApiV1ClientAuthLoginPostResponses, LoginApiV1ClientAuthLoginPostErrors, ThrowOnError>({
    url: '/api/v1/client-auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh
 *
 * Mint a new access token from the refresh cookie + rotate the cookie.
 *
 * The refresh token never appears in a request body — it lives only in
 * the HttpOnly cookie set by login/signup/setup. This is the load-
 * bearing endpoint for the "stay logged in across page refresh" flow:
 * the SPA calls this on mount; if the cookie is valid the user gets
 * fresh tokens, if it's missing or expired they're bounced to login.
 */
export const refreshApiV1ClientAuthRefreshPost = <ThrowOnError extends boolean = false>(options?: Options<RefreshApiV1ClientAuthRefreshPostData, ThrowOnError>) => (options?.client ?? client).post<RefreshApiV1ClientAuthRefreshPostResponses, RefreshApiV1ClientAuthRefreshPostErrors, ThrowOnError>({ url: '/api/v1/client-auth/refresh', ...options });

/**
 * Forgot Password
 *
 * Always returns 204 regardless of whether the email matches — prevents
 * user enumeration via response-content differences.
 *
 * Audit-logged either way (matched or not) so abuse patterns like
 * "1000 /forgot hits from one IP-bucket" are queryable. The audit
 * `matched_existing_client` boolean is post-hoc forensic data, not
 * leaked to the caller — they always see a 204.
 */
export const forgotPasswordApiV1ClientAuthForgotPost = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordApiV1ClientAuthForgotPostData, ThrowOnError>) => (options.client ?? client).post<ForgotPasswordApiV1ClientAuthForgotPostResponses, ForgotPasswordApiV1ClientAuthForgotPostErrors, ThrowOnError>({
    url: '/api/v1/client-auth/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 */
export const resetPasswordApiV1ClientAuthResetResetTokenPost = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordApiV1ClientAuthResetResetTokenPostData, ThrowOnError>) => (options.client ?? client).post<ResetPasswordApiV1ClientAuthResetResetTokenPostResponses, ResetPasswordApiV1ClientAuthResetResetTokenPostErrors, ThrowOnError>({
    url: '/api/v1/client-auth/reset/{reset_token}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Verify Email
 *
 * Re-send the email-verification message for the authenticated
 * client. Idempotent — replaces any pending verify token with a
 * fresh one. Returns 204 in both "sent" and "already verified"
 * cases (don't leak which by status code).
 *
 * Per-client cooldown of 5 minutes prevents abuse + protects the
 * customer's inbox from spam.
 */
export const resendVerifyEmailApiV1ClientAuthResendVerifyPost = <ThrowOnError extends boolean = false>(options?: Options<ResendVerifyEmailApiV1ClientAuthResendVerifyPostData, ThrowOnError>) => (options?.client ?? client).post<ResendVerifyEmailApiV1ClientAuthResendVerifyPostResponses, ResendVerifyEmailApiV1ClientAuthResendVerifyPostErrors, ThrowOnError>({ url: '/api/v1/client-auth/resend-verify', ...options });

/**
 * Logout
 *
 * Revoke the presented refresh token + clear the cookie. Sibling
 * sessions on other devices keep working — logout is per-device unless
 * the client explicitly logs out everywhere (TODO Phase 2b).
 *
 * Always clears the cookie even if the revoke service errors, so a
 * forced logout doesn't leave a dead refresh-token cookie behind for
 * the next bootstrap to choke on.
 */
export const logoutApiV1ClientAuthLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<LogoutApiV1ClientAuthLogoutPostData, ThrowOnError>) => (options?.client ?? client).post<LogoutApiV1ClientAuthLogoutPostResponses, LogoutApiV1ClientAuthLogoutPostErrors, ThrowOnError>({ url: '/api/v1/client-auth/logout', ...options });

/**
 * Me
 */
export const meApiV1ClientAuthMeGet = <ThrowOnError extends boolean = false>(options?: Options<MeApiV1ClientAuthMeGetData, ThrowOnError>) => (options?.client ?? client).get<MeApiV1ClientAuthMeGetResponses, MeApiV1ClientAuthMeGetErrors, ThrowOnError>({ url: '/api/v1/client-auth/me', ...options });

/**
 * Create Engagement Checkout
 *
 * Create a Stripe Checkout Session for one of the buyer's engagements.
 *
 * Authorization invariant: returns 404 (not 403) when the case
 * exists but isn't owned by the authenticated buyer. Avoids leaking
 * the existence of other buyers' cases via status code.
 *
 * The amount is computed server-side from the case's in-scope
 * domain target count. No request body — the buyer cannot
 * influence the price.
 */
export const createEngagementCheckoutApiV1ClientPortalEngagementsCaseIdCheckoutPost = <ThrowOnError extends boolean = false>(options: Options<CreateEngagementCheckoutApiV1ClientPortalEngagementsCaseIdCheckoutPostData, ThrowOnError>) => (options.client ?? client).post<CreateEngagementCheckoutApiV1ClientPortalEngagementsCaseIdCheckoutPostResponses, CreateEngagementCheckoutApiV1ClientPortalEngagementsCaseIdCheckoutPostErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}/checkout', ...options });

/**
 * List Finding Actions
 *
 * Current Take-Action state for every finding in this engagement.
 *
 * Returns only the latest action per finding (via
 * client_finding_action_current view), and only for engagements the
 * authenticated client owns.
 */
export const listFindingActionsApiV1ClientPortalEngagementsCaseIdFindingActionsGet = <ThrowOnError extends boolean = false>(options: Options<ListFindingActionsApiV1ClientPortalEngagementsCaseIdFindingActionsGetData, ThrowOnError>) => (options.client ?? client).get<ListFindingActionsApiV1ClientPortalEngagementsCaseIdFindingActionsGetResponses, ListFindingActionsApiV1ClientPortalEngagementsCaseIdFindingActionsGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}/finding-actions', ...options });

/**
 * Record Finding Action
 *
 * Record the buyer's current Take-Action state for one finding.
 *
 * Append-only — each call inserts a new row capturing the transition.
 */
export const recordFindingActionApiV1ClientPortalFindingsEvidenceCardIdActionPost = <ThrowOnError extends boolean = false>(options: Options<RecordFindingActionApiV1ClientPortalFindingsEvidenceCardIdActionPostData, ThrowOnError>) => (options.client ?? client).post<RecordFindingActionApiV1ClientPortalFindingsEvidenceCardIdActionPostResponses, RecordFindingActionApiV1ClientPortalFindingsEvidenceCardIdActionPostErrors, ThrowOnError>({
    url: '/api/v1/client-portal/findings/{evidence_card_id}/action',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Finding Comments
 *
 * Read the comment thread on one of the buyer's findings.
 *
 * Tenant isolation: returns 404 if the card doesn't exist OR if
 * it belongs to a case the authenticated client doesn't own. Same
 * posture as record_finding_action.
 */
export const listFindingCommentsApiV1ClientPortalFindingsEvidenceCardIdCommentsGet = <ThrowOnError extends boolean = false>(options: Options<ListFindingCommentsApiV1ClientPortalFindingsEvidenceCardIdCommentsGetData, ThrowOnError>) => (options.client ?? client).get<ListFindingCommentsApiV1ClientPortalFindingsEvidenceCardIdCommentsGetResponses, ListFindingCommentsApiV1ClientPortalFindingsEvidenceCardIdCommentsGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/findings/{evidence_card_id}/comments', ...options });

/**
 * Post Finding Comment
 *
 * Buyer posts a comment on one of their findings.
 *
 * Append-only: each call inserts a new row. Cross-tenant attempts
 * return 404 instead of 403.
 */
export const postFindingCommentApiV1ClientPortalFindingsEvidenceCardIdCommentsPost = <ThrowOnError extends boolean = false>(options: Options<PostFindingCommentApiV1ClientPortalFindingsEvidenceCardIdCommentsPostData, ThrowOnError>) => (options.client ?? client).post<PostFindingCommentApiV1ClientPortalFindingsEvidenceCardIdCommentsPostResponses, PostFindingCommentApiV1ClientPortalFindingsEvidenceCardIdCommentsPostErrors, ThrowOnError>({
    url: '/api/v1/client-portal/findings/{evidence_card_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Finding Verification
 *
 * Trigger a re-test of the original detection against the same target.
 *
 * Validation gates (all 422 with a specific reason):
 * - Finding must belong to one of the buyer's cases (else 404).
 * - Latest action state must be `fixed`.
 * - Latest action must not already be verified.
 * - Finding must have an originating tool_run + identity hash.
 * - No re-test for this finding may currently be queued/running.
 *
 * On success: the child tool_run is created with parent_tool_run_id
 * set to the original, the response returns immediately (202 Accepted),
 * and a FastAPI BackgroundTask drives execution + post-completion
 * verification recording. The frontend polls the tool_run by id to
 * watch progress, then re-fetches finding-actions to see the verified
 * state appear when the fix held.
 */
export const requestFindingVerificationApiV1ClientPortalFindingsEvidenceCardIdVerifyFixPost = <ThrowOnError extends boolean = false>(options: Options<RequestFindingVerificationApiV1ClientPortalFindingsEvidenceCardIdVerifyFixPostData, ThrowOnError>) => (options.client ?? client).post<RequestFindingVerificationApiV1ClientPortalFindingsEvidenceCardIdVerifyFixPostResponses, RequestFindingVerificationApiV1ClientPortalFindingsEvidenceCardIdVerifyFixPostErrors, ThrowOnError>({ url: '/api/v1/client-portal/findings/{evidence_card_id}/verify-fix', ...options });

/**
 * Download Client Report Pdf
 *
 * Return the report PDF for download, authenticated as the buyer.
 *
 * Authorization invariant: returns 404 (not 403) when the case
 * exists but isn't owned by the authenticated client, OR when the
 * report exists but isn't attached to the requested case. Avoids
 * leaking the existence of either object across tenant boundaries.
 */
export const downloadClientReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdPdfGet = <ThrowOnError extends boolean = false>(options: Options<DownloadClientReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdPdfGetData, ThrowOnError>) => (options.client ?? client).get<DownloadClientReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdPdfGetResponses, DownloadClientReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdPdfGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}/reports/{report_id}/pdf', ...options });

/**
 * Preview Cart Pricing
 *
 * Server-authoritative price breakdown for a draft cart.
 *
 * Used by the SPA to display the live total as the buyer adds /
 * removes assets. Returns a structured `line_items` array the UI
 * renders verbatim (preventing the SPA from inventing its own
 * pricing copy that drifts from what's actually charged).
 *
 * Validation errors come back as `error` in the response (200, not
 * 422) so the SPA can highlight the offending row without losing
 * the rest of the cart state.
 */
export const previewCartPricingApiV1ClientPortalPricingPreviewPost = <ThrowOnError extends boolean = false>(options: Options<PreviewCartPricingApiV1ClientPortalPricingPreviewPostData, ThrowOnError>) => (options.client ?? client).post<PreviewCartPricingApiV1ClientPortalPricingPreviewPostResponses, PreviewCartPricingApiV1ClientPortalPricingPreviewPostErrors, ThrowOnError>({
    url: '/api/v1/client-portal/pricing/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Commission Engagement
 *
 * Pattern B commission flow — no case row until payment confirmed.
 *
 * 1. Validate the cart from `body.targets` (server-authoritative
 * domain/subdomain classification — buyers cannot smuggle a
 * subdomain in as a "domain" to pay the cheaper rate).
 * 2. Compute the price server-side via `calculate_cart_price`.
 * 3. Insert a `pending_intake` row with the snapshot + price.
 * 4. Create a Stripe Checkout Session (with promotion codes enabled).
 * 5. Backfill `stripe_checkout_session_id` on the pending_intake.
 * 6. Return the Stripe URL — the SPA redirects directly.
 *
 * On `checkout.session.completed` the webhook reconstructs the
 * IntakeRequest from the snapshot and runs the existing
 * `intake_service.process_intake` pipeline to create the case +
 * targets + attestation. On `checkout.session.expired` the
 * pending_intake row is deleted; no ghost case rows ever appear.
 */
export const commissionEngagementApiV1ClientPortalCommissionPost = <ThrowOnError extends boolean = false>(options: Options<CommissionEngagementApiV1ClientPortalCommissionPostData, ThrowOnError>) => (options.client ?? client).post<CommissionEngagementApiV1ClientPortalCommissionPostResponses, CommissionEngagementApiV1ClientPortalCommissionPostErrors, ThrowOnError>({
    url: '/api/v1/client-portal/commission',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Engagement Activity
 *
 * Unified activity feed for one engagement (Bucket QQ-W3).
 *
 * Returns recipient views/downloads, finding comments (from all three
 * actors), and the buyer's own finding-action transitions — merged
 * into a single chronological list, newest first.
 *
 * Tenant isolation: the service verifies case ownership before
 * running any queries. A buyer requesting a case they don't own
 * gets an empty list rather than a 404 — the unified shape doesn't
 * distinguish "no activity" from "no access" because that
 * distinction isn't load-bearing for the feed UX.
 */
export const getEngagementActivityApiV1ClientPortalEngagementsCaseIdActivityGet = <ThrowOnError extends boolean = false>(options: Options<GetEngagementActivityApiV1ClientPortalEngagementsCaseIdActivityGetData, ThrowOnError>) => (options.client ?? client).get<GetEngagementActivityApiV1ClientPortalEngagementsCaseIdActivityGetResponses, GetEngagementActivityApiV1ClientPortalEngagementsCaseIdActivityGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}/activity', ...options });

/**
 * Get Dashboard Pulse
 *
 * Hero-strip data for the /Recon dashboard (Bucket QP-W3).
 *
 * Single round-trip returning three panels:
 * - `next_action`: the highest-priority still-actionable finding
 * across the buyer's engagements (or None if all clear).
 * - `stats`: counts by lifecycle state (todo, acknowledged,
 * in_progress, fixed, accepted_risk, needs_help).
 * - `sparkline`: 90 daily open-finding counts for the burn-down.
 *
 * Tenant-isolated by client_id in every underlying SQL statement.
 * Returns the same shape with empty/zero data for buyers with no
 * findings yet — the dashboard renders the empty state from the
 * shape, not from a 404.
 */
export const getDashboardPulseApiV1ClientPortalPulseGet = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardPulseApiV1ClientPortalPulseGetData, ThrowOnError>) => (options?.client ?? client).get<GetDashboardPulseApiV1ClientPortalPulseGetResponses, GetDashboardPulseApiV1ClientPortalPulseGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/pulse', ...options });

/**
 * List Engagements
 *
 * List engagements (cases) belonging to the authenticated client.
 *
 * Returns the lightweight summary needed for the dashboard — case
 * number, title, status, key timestamps, payment + signed flags.
 * Detailed deliverables (reports, evidence) come from the
 * detail endpoint.
 */
export const listEngagementsApiV1ClientPortalEngagementsGet = <ThrowOnError extends boolean = false>(options?: Options<ListEngagementsApiV1ClientPortalEngagementsGetData, ThrowOnError>) => (options?.client ?? client).get<ListEngagementsApiV1ClientPortalEngagementsGetResponses, ListEngagementsApiV1ClientPortalEngagementsGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements', ...options });

/**
 * Get Engagement
 *
 * Return full client-visible detail for one engagement.
 *
 * Authorization invariant: returns 404 (not 403) when the case exists
 * but isn't owned by the authenticated client. Avoids leaking the
 * existence of other clients' engagements via a different status code.
 */
export const getEngagementApiV1ClientPortalEngagementsCaseIdGet = <ThrowOnError extends boolean = false>(options: Options<GetEngagementApiV1ClientPortalEngagementsCaseIdGetData, ThrowOnError>) => (options.client ?? client).get<GetEngagementApiV1ClientPortalEngagementsCaseIdGetResponses, GetEngagementApiV1ClientPortalEngagementsCaseIdGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}', ...options });

/**
 * Get Report Payload
 *
 * Return the frozen JSON payload for a published report.
 *
 * Data source for the HTML viewer at /portal/reports/:id/html. The
 * payload is the canonical record built at publish time; the PDF and
 * HTML viewer both render from it. See
 * apps/api/docs/report-payload-schema.md for the schema.
 *
 * The CHECK constraint ck_report_published_has_payload (migration 0017)
 * guarantees that every status='published' row has a non-NULL payload,
 * so this endpoint never has to handle "published but no payload" as a
 * runtime case. Drafts and not-yet-published statuses return 404.
 *
 * Authorization: returns 404 if either (a) the case isn't owned by the
 * authenticated client or (b) the report doesn't belong to that case.
 * Same status-code-leakage posture as get_engagement above — a 403
 * would tell an attacker the resource exists.
 */
export const getReportPayloadApiV1ClientPortalEngagementsCaseIdReportsReportIdPayloadGet = <ThrowOnError extends boolean = false>(options: Options<GetReportPayloadApiV1ClientPortalEngagementsCaseIdReportsReportIdPayloadGetData, ThrowOnError>) => (options.client ?? client).get<GetReportPayloadApiV1ClientPortalEngagementsCaseIdReportsReportIdPayloadGetResponses, GetReportPayloadApiV1ClientPortalEngagementsCaseIdReportsReportIdPayloadGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}/reports/{report_id}/payload', ...options });

/**
 * Download Anonymized Report Pdf
 *
 * Render the report as an anonymized PDF for the authenticated client.
 *
 * Client-self-serve variant of the investigator anonymized HTML preview
 * at /reports/{report_id}/anonymized.html. Use case: the buyer wants to
 * forward a copy of their report to a third party (board member,
 * insurance underwriter, M&A counterparty, prospective customer asking
 * for due diligence) without revealing buyer identity, target domains,
 * or contact information.
 *
 * The anonymization swaps in stable plausible placeholders and stamps
 * a 'SAMPLE — ANONYMIZED' watermark on every page so the output can
 * never be confused with the original signed deliverable. The original
 * signed report remains untouched.
 *
 * Authorization: same 404-on-anything-not-owned pattern as
 * get_report_payload. Only published reports are anonymizable through
 * this endpoint (drafts and unpublished statuses 404).
 */
export const downloadAnonymizedReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdAnonymizedPdfGet = <ThrowOnError extends boolean = false>(options: Options<DownloadAnonymizedReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdAnonymizedPdfGetData, ThrowOnError>) => (options.client ?? client).get<DownloadAnonymizedReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdAnonymizedPdfGetResponses, DownloadAnonymizedReportPdfApiV1ClientPortalEngagementsCaseIdReportsReportIdAnonymizedPdfGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}/reports/{report_id}/anonymized.pdf', ...options });

/**
 * List Trust Entries
 *
 * List the buyer's trust-bank entries.
 *
 * Active entries first; pass `?include_archived=true` to also see
 * soft-deleted ones (for re-activation flows + audit context).
 */
export const listTrustEntriesApiV1ClientPortalTrustEntriesGet = <ThrowOnError extends boolean = false>(options?: Options<ListTrustEntriesApiV1ClientPortalTrustEntriesGetData, ThrowOnError>) => (options?.client ?? client).get<ListTrustEntriesApiV1ClientPortalTrustEntriesGetResponses, ListTrustEntriesApiV1ClientPortalTrustEntriesGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/trust-entries', ...options });

/**
 * Add Trust Entry
 *
 * Add an email or domain to the buyer's trust bank.
 *
 * 409 if the entry is already active for this client. Re-adding an
 * archived entry succeeds (the partial unique index excludes archived
 * rows).
 */
export const addTrustEntryApiV1ClientPortalTrustEntriesPost = <ThrowOnError extends boolean = false>(options: Options<AddTrustEntryApiV1ClientPortalTrustEntriesPostData, ThrowOnError>) => (options.client ?? client).post<AddTrustEntryApiV1ClientPortalTrustEntriesPostResponses, AddTrustEntryApiV1ClientPortalTrustEntriesPostErrors, ThrowOnError>({
    url: '/api/v1/client-portal/trust-entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive Trust Entry
 *
 * Soft-delete (archive) one trust-bank entry.
 *
 * The row stays in the table for audit history but stops counting as
 * active — the partial unique index lets the buyer re-add the same
 * vendor later if the relationship resumes. Idempotent: calling
 * twice on the same entry is fine.
 */
export const archiveTrustEntryApiV1ClientPortalTrustEntriesEntryIdDelete = <ThrowOnError extends boolean = false>(options: Options<ArchiveTrustEntryApiV1ClientPortalTrustEntriesEntryIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<ArchiveTrustEntryApiV1ClientPortalTrustEntriesEntryIdDeleteResponses, ArchiveTrustEntryApiV1ClientPortalTrustEntriesEntryIdDeleteErrors, ThrowOnError>({ url: '/api/v1/client-portal/trust-entries/{entry_id}', ...options });

/**
 * List Shares For Report
 *
 * List all shares (active + revoked) the buyer has created for this
 * report. Includes last-access timestamp + access count summarized
 * from recipient_access_event so the buyer can see distribution health
 * at a glance.
 */
export const listSharesForReportApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesGet = <ThrowOnError extends boolean = false>(options: Options<ListSharesForReportApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesGetData, ThrowOnError>) => (options.client ?? client).get<ListSharesForReportApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesGetResponses, ListSharesForReportApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/engagements/{case_id}/reports/{report_id}/shares', ...options });

/**
 * Create Share
 *
 * Mint a recipient-access token for a published report.
 *
 * The cleartext token is returned ONCE. The buyer copies it (along
 * with the canned share message) into whatever channel they use to
 * reach their recipients. Recipients then visit /validate and enter
 * the token; the trust-bank or specific-* match check decides if
 * they're authorized.
 */
export const createShareApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesPost = <ThrowOnError extends boolean = false>(options: Options<CreateShareApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesPostData, ThrowOnError>) => (options.client ?? client).post<CreateShareApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesPostResponses, CreateShareApiV1ClientPortalEngagementsCaseIdReportsReportIdSharesPostErrors, ThrowOnError>({
    url: '/api/v1/client-portal/engagements/{case_id}/reports/{report_id}/shares',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Share
 *
 * Revoke a share. Idempotent at the API: revoking an already-revoked
 * grant returns 204 (the underlying trigger forbids re-revocation, so
 * the service filters out already-revoked rows).
 */
export const revokeShareApiV1ClientPortalSharesGrantIdRevokePost = <ThrowOnError extends boolean = false>(options: Options<RevokeShareApiV1ClientPortalSharesGrantIdRevokePostData, ThrowOnError>) => (options.client ?? client).post<RevokeShareApiV1ClientPortalSharesGrantIdRevokePostResponses, RevokeShareApiV1ClientPortalSharesGrantIdRevokePostErrors, ThrowOnError>({ url: '/api/v1/client-portal/shares/{grant_id}/revoke', ...options });

/**
 * List Share Access Log
 *
 * Return the access log for a share (newest first, capped at 500
 * rows). Buyer-side audit visibility — every validate attempt, every
 * view, every download for that one share.
 */
export const listShareAccessLogApiV1ClientPortalSharesGrantIdAccessLogGet = <ThrowOnError extends boolean = false>(options: Options<ListShareAccessLogApiV1ClientPortalSharesGrantIdAccessLogGetData, ThrowOnError>) => (options.client ?? client).get<ListShareAccessLogApiV1ClientPortalSharesGrantIdAccessLogGetResponses, ListShareAccessLogApiV1ClientPortalSharesGrantIdAccessLogGetErrors, ThrowOnError>({ url: '/api/v1/client-portal/shares/{grant_id}/access-log', ...options });

/**
 * Submit Validation
 *
 * Validate a token + email pair, send a magic-link email on match.
 *
 * Always returns 202 Accepted with a generic message. The buyer sees
 * the actual outcome via the access log; the recipient sees only the
 * email (or its absence).
 */
export const submitValidationApiV1ValidatePost = <ThrowOnError extends boolean = false>(options: Options<SubmitValidationApiV1ValidatePostData, ThrowOnError>) => (options.client ?? client).post<SubmitValidationApiV1ValidatePostResponses, SubmitValidationApiV1ValidatePostErrors, ThrowOnError>({
    url: '/api/v1/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Validation
 *
 * Magic-link landing. Verifies + sets the share-session cookie.
 *
 * Returns minimal HTML that auto-redirects the browser to
 * /validate/success?grant=... on the SPA. The SPA pulls the deliverable
 * via /api/v1/validate/{share_token}/payload using the cookie just set.
 */
export const confirmValidationApiV1ValidateConfirmMagicTokenGet = <ThrowOnError extends boolean = false>(options: Options<ConfirmValidationApiV1ValidateConfirmMagicTokenGetData, ThrowOnError>) => (options.client ?? client).get<ConfirmValidationApiV1ValidateConfirmMagicTokenGetResponses, ConfirmValidationApiV1ValidateConfirmMagicTokenGetErrors, ThrowOnError>({ url: '/api/v1/validate/confirm/{magic_token}', ...options });

/**
 * Get Validated Payload
 *
 * Recipient-side payload fetch. Cookie carries the grant_id; the
 * URL grant_id MUST match (otherwise the cookie was stolen / reused).
 */
export const getValidatedPayloadApiV1ValidateGrantIdPayloadGet = <ThrowOnError extends boolean = false>(options: Options<GetValidatedPayloadApiV1ValidateGrantIdPayloadGetData, ThrowOnError>) => (options.client ?? client).get<GetValidatedPayloadApiV1ValidateGrantIdPayloadGetResponses, GetValidatedPayloadApiV1ValidateGrantIdPayloadGetErrors, ThrowOnError>({ url: '/api/v1/validate/{grant_id}/payload', ...options });

/**
 * Download Validated Pdf
 *
 * Recipient-side PDF download. Subject to grant.allow_download.
 *
 * Q3 wires per-render watermarking (recipient identity overlay); for
 * Q2 we serve the existing PDF rendering as a placeholder.
 */
export const downloadValidatedPdfApiV1ValidateGrantIdPdfGet = <ThrowOnError extends boolean = false>(options: Options<DownloadValidatedPdfApiV1ValidateGrantIdPdfGetData, ThrowOnError>) => (options.client ?? client).get<DownloadValidatedPdfApiV1ValidateGrantIdPdfGetResponses, DownloadValidatedPdfApiV1ValidateGrantIdPdfGetErrors, ThrowOnError>({ url: '/api/v1/validate/{grant_id}/pdf', ...options });

/**
 * Recipient List Finding Comments
 *
 * Recipient reads the comment thread on a finding within their share.
 *
 * Auth:
 * - share-session cookie must be present (claims dependency).
 * - cookie's grant_id must match the path grant_id.
 * - the finding's case must match the grant's report's case.
 *
 * Permission level doesn't gate reads — Viewer-tier recipients can
 * see the thread; only writes are restricted to Collaborator-tier.
 */
export const recipientListFindingCommentsApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsGet = <ThrowOnError extends boolean = false>(options: Options<RecipientListFindingCommentsApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsGetData, ThrowOnError>) => (options.client ?? client).get<RecipientListFindingCommentsApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsGetResponses, RecipientListFindingCommentsApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsGetErrors, ThrowOnError>({ url: '/api/v1/validate/{grant_id}/findings/{evidence_card_id}/comments', ...options });

/**
 * Recipient Post Finding Comment
 *
 * Collaborator-tier recipient posts a comment on a finding.
 *
 * Returns 422 with a specific reason on:
 * - Viewer-tier grant (cannot post)
 * - Revoked/expired grant
 * - Cross-case attempt (treated as 404 to avoid leakage)
 */
export const recipientPostFindingCommentApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsPost = <ThrowOnError extends boolean = false>(options: Options<RecipientPostFindingCommentApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsPostData, ThrowOnError>) => (options.client ?? client).post<RecipientPostFindingCommentApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsPostResponses, RecipientPostFindingCommentApiV1ValidateGrantIdFindingsEvidenceCardIdCommentsPostErrors, ThrowOnError>({
    url: '/api/v1/validate/{grant_id}/findings/{evidence_card_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Report
 *
 * Public verification endpoint. Returns signature status only.
 */
export const verifyReportVerifyCaseNumberReportIdGet = <ThrowOnError extends boolean = false>(options: Options<VerifyReportVerifyCaseNumberReportIdGetData, ThrowOnError>) => (options.client ?? client).get<VerifyReportVerifyCaseNumberReportIdGetResponses, VerifyReportVerifyCaseNumberReportIdGetErrors, ThrowOnError>({ url: '/verify/{case_number}/{report_id}', ...options });

/**
 * Login
 *
 * Investigator login: username + password + TOTP in one request.
 *
 * Returns access + refresh tokens on success.
 * Raises 401 (InvalidCredentials or TOTPRequired) or 423 (AccountLocked).
 */
export const loginApiV1AuthLoginPost = <ThrowOnError extends boolean = false>(options: Options<LoginApiV1AuthLoginPostData, ThrowOnError>) => (options.client ?? client).post<LoginApiV1AuthLoginPostResponses, LoginApiV1AuthLoginPostErrors, ThrowOnError>({
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Token
 *
 * Refresh an access token using a valid refresh token.
 *
 * Rotates the refresh token: the old one is revoked, a new one is
 * returned. Reuse detection: if the old token was already revoked,
 * the entire family is revoked.
 */
export const refreshTokenApiV1AuthRefreshPost = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenApiV1AuthRefreshPostData, ThrowOnError>) => (options.client ?? client).post<RefreshTokenApiV1AuthRefreshPostResponses, RefreshTokenApiV1AuthRefreshPostErrors, ThrowOnError>({
    url: '/api/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout
 *
 * Logout: revoke the refresh token family.
 *
 * Requires a valid access token (to identify the investigator) AND the
 * refresh token to revoke (in the body). Returns 204 No Content on
 * success.
 */
export const logoutApiV1AuthLogoutPost = <ThrowOnError extends boolean = false>(options: Options<LogoutApiV1AuthLogoutPostData, ThrowOnError>) => (options.client ?? client).post<LogoutApiV1AuthLogoutPostResponses, LogoutApiV1AuthLogoutPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Cases
 *
 * List cases with optional filters and pagination.
 */
export const listCasesApiV1CasesGet = <ThrowOnError extends boolean = false>(options?: Options<ListCasesApiV1CasesGetData, ThrowOnError>) => (options?.client ?? client).get<ListCasesApiV1CasesGetResponses, ListCasesApiV1CasesGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases',
    ...options
});

/**
 * Create Case
 *
 * Create a new case. Returns the created case with auto-generated case_number.
 */
export const createCaseApiV1CasesPost = <ThrowOnError extends boolean = false>(options: Options<CreateCaseApiV1CasesPostData, ThrowOnError>) => (options.client ?? client).post<CreateCaseApiV1CasesPostResponses, CreateCaseApiV1CasesPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Case
 *
 * Get a single case by ID.
 */
export const getCaseApiV1CasesCaseIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCaseApiV1CasesCaseIdGetData, ThrowOnError>) => (options.client ?? client).get<GetCaseApiV1CasesCaseIdGetResponses, GetCaseApiV1CasesCaseIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}',
    ...options
});

/**
 * Update Case
 *
 * Update mutable case fields (title, scope, billing, etc.).
 */
export const updateCaseApiV1CasesCaseIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateCaseApiV1CasesCaseIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateCaseApiV1CasesCaseIdPatchResponses, UpdateCaseApiV1CasesCaseIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition Case Status
 *
 * Transition a case's status. Returns the updated case.
 *
 * Valid forward transitions: intake → active → review → delivered → closed.
 * Reverse transitions are allowed with a required `reason` field.
 */
export const transitionCaseStatusApiV1CasesCaseIdStatusPost = <ThrowOnError extends boolean = false>(options: Options<TransitionCaseStatusApiV1CasesCaseIdStatusPostData, ThrowOnError>) => (options.client ?? client).post<TransitionCaseStatusApiV1CasesCaseIdStatusPostResponses, TransitionCaseStatusApiV1CasesCaseIdStatusPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Operator Attest Case
 *
 * Operator-side attestation for cases created outside the buyer
 * intake flow.
 *
 * The buyer-driven HackerEyes intake form creates an engagement_attestation
 * row as a side-effect of commission submission, where the buyer types
 * their legal name in the attestation box. Cases created directly by the
 * operator in Operative (e.g. for internal testing or for engagements
 * where the legal authorization lives outside the platform via a signed
 * letter of engagement / SOW) had no path to that gate — every tool
 * dispatch fell at the dispatch-time scope check.
 *
 * This endpoint lets the operator attest on behalf of an engagement
 * where they hold the legal authorization out-of-band. Body fields are
 * all optional; sensible defaults:
 * - attested_name → investigator.full_name (the operator)
 * - attested_contact_email → investigator.email
 * - domain_snapshot → built from the case's in-scope domain targets
 *
 * The attestation row uses the same trigger-enforced immutability +
 * hash-match guards as the buyer-driven path. Operator attestations
 * DO go in audit_log (action='engagement_attested_by_operator') so the
 * legal record reflects who attested, when, and from where.
 *
 * Body shape (all optional):
 * {
 * "attested_name": "Jason Lloyd",          // default: operator's name
 * "attested_contact_email": "...",          // default: operator's email
 * "domain_overrides": ["acme.com", ...]     // default: case's domains
 * }
 */
export const operatorAttestCaseApiV1CasesCaseIdOperatorAttestPost = <ThrowOnError extends boolean = false>(options: Options<OperatorAttestCaseApiV1CasesCaseIdOperatorAttestPostData, ThrowOnError>) => (options.client ?? client).post<OperatorAttestCaseApiV1CasesCaseIdOperatorAttestPostResponses, OperatorAttestCaseApiV1CasesCaseIdOperatorAttestPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/operator-attest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Case Timeline
 *
 * Get timeline of all events for a case from the audit log.
 */
export const getCaseTimelineApiV1CasesCaseIdTimelineGet = <ThrowOnError extends boolean = false>(options: Options<GetCaseTimelineApiV1CasesCaseIdTimelineGetData, ThrowOnError>) => (options.client ?? client).get<GetCaseTimelineApiV1CasesCaseIdTimelineGetResponses, GetCaseTimelineApiV1CasesCaseIdTimelineGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/timeline',
    ...options
});

/**
 * List Case Notifications
 *
 * Investigator-facing read of the QP-W2 notification ledger for a case.
 *
 * Surfaces every notification we attempted to send the buyer about
 * this case, newest first. Covers the audit gap "did we tell the
 * buyer about X?" — the buyer's portal shows their own inbox, the
 * operator never sees the outbox without this view.
 *
 * Each row carries kind, status, recipient email, subject, body,
 * drop reason (when suppressed/failed), context jsonb, created_at,
 * and sent_at. The trigger on notification_event guarantees these
 * rows are append-only, so the operator's view is a permanent
 * record of the case's communication footprint.
 */
export const listCaseNotificationsApiV1CasesCaseIdNotificationsGet = <ThrowOnError extends boolean = false>(options: Options<ListCaseNotificationsApiV1CasesCaseIdNotificationsGetData, ThrowOnError>) => (options.client ?? client).get<ListCaseNotificationsApiV1CasesCaseIdNotificationsGetResponses, ListCaseNotificationsApiV1CasesCaseIdNotificationsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/notifications',
    ...options
});

/**
 * List Targets
 */
export const listTargetsApiV1CasesCaseIdTargetsGet = <ThrowOnError extends boolean = false>(options: Options<ListTargetsApiV1CasesCaseIdTargetsGetData, ThrowOnError>) => (options.client ?? client).get<ListTargetsApiV1CasesCaseIdTargetsGetResponses, ListTargetsApiV1CasesCaseIdTargetsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/targets',
    ...options
});

/**
 * Create Target
 */
export const createTargetApiV1CasesCaseIdTargetsPost = <ThrowOnError extends boolean = false>(options: Options<CreateTargetApiV1CasesCaseIdTargetsPostData, ThrowOnError>) => (options.client ?? client).post<CreateTargetApiV1CasesCaseIdTargetsPostResponses, CreateTargetApiV1CasesCaseIdTargetsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/targets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Target
 */
export const deleteTargetApiV1TargetsTargetIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteTargetApiV1TargetsTargetIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteTargetApiV1TargetsTargetIdDeleteResponses, DeleteTargetApiV1TargetsTargetIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/targets/{target_id}',
    ...options
});

/**
 * Update Target
 */
export const updateTargetApiV1TargetsTargetIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateTargetApiV1TargetsTargetIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateTargetApiV1TargetsTargetIdPatchResponses, UpdateTargetApiV1TargetsTargetIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/targets/{target_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Target Scope
 *
 * Mark a confirmed target as in-scope or out-of-scope. Out-of-scope
 * targets stay documented but are skipped by scan plans and rejected by
 * tool-run triggers. Suggestions can't be marked out of scope — Promote
 * them first or Dismiss them.
 */
export const setTargetScopeApiV1TargetsTargetIdScopePost = <ThrowOnError extends boolean = false>(options: Options<SetTargetScopeApiV1TargetsTargetIdScopePostData, ThrowOnError>) => (options.client ?? client).post<SetTargetScopeApiV1TargetsTargetIdScopePostResponses, SetTargetScopeApiV1TargetsTargetIdScopePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/targets/{target_id}/scope',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Promote Target
 *
 * Promote an auto-discovered suggestion to a confirmed target.
 */
export const promoteTargetApiV1TargetsTargetIdPromotePost = <ThrowOnError extends boolean = false>(options: Options<PromoteTargetApiV1TargetsTargetIdPromotePostData, ThrowOnError>) => (options.client ?? client).post<PromoteTargetApiV1TargetsTargetIdPromotePostResponses, PromoteTargetApiV1TargetsTargetIdPromotePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/targets/{target_id}/promote',
    ...options
});

/**
 * Reset Case Tool Data
 *
 * Wipe tool runs + evidence + suggestions for a case so it can re-run
 * from scratch. User-identified targets and previously-promoted targets
 * stay. The scan plan structure stays — only its execution artifacts
 * get cleared.
 */
export const resetCaseToolDataApiV1CasesCaseIdResetToolDataPost = <ThrowOnError extends boolean = false>(options: Options<ResetCaseToolDataApiV1CasesCaseIdResetToolDataPostData, ThrowOnError>) => (options.client ?? client).post<ResetCaseToolDataApiV1CasesCaseIdResetToolDataPostResponses, ResetCaseToolDataApiV1CasesCaseIdResetToolDataPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/reset-tool-data',
    ...options
});

/**
 * List Evidence Cards
 *
 * List evidence cards for a case (via its targets).
 *
 * Joins finding_state_current to expose the operator's lifecycle
 * judgment alongside the immutable observation. A NULL state column
 * means no state was ever set — the UI treats that as `open`.
 */
export const listEvidenceCardsApiV1CasesCaseIdEvidenceGet = <ThrowOnError extends boolean = false>(options: Options<ListEvidenceCardsApiV1CasesCaseIdEvidenceGetData, ThrowOnError>) => (options.client ?? client).get<ListEvidenceCardsApiV1CasesCaseIdEvidenceGetResponses, ListEvidenceCardsApiV1CasesCaseIdEvidenceGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/evidence',
    ...options
});

/**
 * Create Evidence Card
 *
 * Create a manual evidence card.
 */
export const createEvidenceCardApiV1CasesCaseIdEvidencePost = <ThrowOnError extends boolean = false>(options: Options<CreateEvidenceCardApiV1CasesCaseIdEvidencePostData, ThrowOnError>) => (options.client ?? client).post<CreateEvidenceCardApiV1CasesCaseIdEvidencePostResponses, CreateEvidenceCardApiV1CasesCaseIdEvidencePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/evidence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Evidence Card
 */
export const getEvidenceCardApiV1EvidenceEvidenceIdGet = <ThrowOnError extends boolean = false>(options: Options<GetEvidenceCardApiV1EvidenceEvidenceIdGetData, ThrowOnError>) => (options.client ?? client).get<GetEvidenceCardApiV1EvidenceEvidenceIdGetResponses, GetEvidenceCardApiV1EvidenceEvidenceIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evidence/{evidence_id}',
    ...options
});

/**
 * Supersede Evidence Card
 *
 * Create a corrected evidence card superseding this one (immutability).
 */
export const supersedeEvidenceCardApiV1EvidenceEvidenceIdSupersedePost = <ThrowOnError extends boolean = false>(options: Options<SupersedeEvidenceCardApiV1EvidenceEvidenceIdSupersedePostData, ThrowOnError>) => (options.client ?? client).post<SupersedeEvidenceCardApiV1EvidenceEvidenceIdSupersedePostResponses, SupersedeEvidenceCardApiV1EvidenceEvidenceIdSupersedePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evidence/{evidence_id}/supersede',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Finding State
 *
 * Return the latest finding-state row for an evidence card.
 *
 * Returns null when no operator state has been set — the card is
 * implicitly `open` in that case.
 */
export const getFindingStateApiV1EvidenceEvidenceIdStateGet = <ThrowOnError extends boolean = false>(options: Options<GetFindingStateApiV1EvidenceEvidenceIdStateGetData, ThrowOnError>) => (options.client ?? client).get<GetFindingStateApiV1EvidenceEvidenceIdStateGetResponses, GetFindingStateApiV1EvidenceEvidenceIdStateGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evidence/{evidence_id}/state',
    ...options
});

/**
 * Set Finding State
 *
 * Record an operator's lifecycle judgment over an evidence card.
 *
 * Append-only: each call writes a new finding_state row. The latest row
 * is the current state. There is no UPDATE path; "changing" a state is
 * a new row.
 */
export const setFindingStateApiV1EvidenceEvidenceIdStatePost = <ThrowOnError extends boolean = false>(options: Options<SetFindingStateApiV1EvidenceEvidenceIdStatePostData, ThrowOnError>) => (options.client ?? client).post<SetFindingStateApiV1EvidenceEvidenceIdStatePostResponses, SetFindingStateApiV1EvidenceEvidenceIdStatePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evidence/{evidence_id}/state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assessor List Finding Comments
 *
 * Investigator-side read of the comment thread on a finding.
 *
 * No tenant filter — investigators see every case's comments.
 */
export const assessorListFindingCommentsApiV1FindingsEvidenceCardIdCommentsGet = <ThrowOnError extends boolean = false>(options: Options<AssessorListFindingCommentsApiV1FindingsEvidenceCardIdCommentsGetData, ThrowOnError>) => (options.client ?? client).get<AssessorListFindingCommentsApiV1FindingsEvidenceCardIdCommentsGetResponses, AssessorListFindingCommentsApiV1FindingsEvidenceCardIdCommentsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/findings/{evidence_card_id}/comments',
    ...options
});

/**
 * Assessor Post Finding Comment
 *
 * Investigator posts a comment on a finding.
 */
export const assessorPostFindingCommentApiV1FindingsEvidenceCardIdCommentsPost = <ThrowOnError extends boolean = false>(options: Options<AssessorPostFindingCommentApiV1FindingsEvidenceCardIdCommentsPostData, ThrowOnError>) => (options.client ?? client).post<AssessorPostFindingCommentApiV1FindingsEvidenceCardIdCommentsPostResponses, AssessorPostFindingCommentApiV1FindingsEvidenceCardIdCommentsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/findings/{evidence_card_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tasks
 */
export const listTasksApiV1CasesCaseIdTasksGet = <ThrowOnError extends boolean = false>(options: Options<ListTasksApiV1CasesCaseIdTasksGetData, ThrowOnError>) => (options.client ?? client).get<ListTasksApiV1CasesCaseIdTasksGetResponses, ListTasksApiV1CasesCaseIdTasksGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/tasks',
    ...options
});

/**
 * Create Task
 */
export const createTaskApiV1CasesCaseIdTasksPost = <ThrowOnError extends boolean = false>(options: Options<CreateTaskApiV1CasesCaseIdTasksPostData, ThrowOnError>) => (options.client ?? client).post<CreateTaskApiV1CasesCaseIdTasksPostResponses, CreateTaskApiV1CasesCaseIdTasksPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Task
 */
export const deleteTaskApiV1TasksTaskIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskApiV1TasksTaskIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteTaskApiV1TasksTaskIdDeleteResponses, DeleteTaskApiV1TasksTaskIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{task_id}',
    ...options
});

/**
 * Update Task
 */
export const updateTaskApiV1TasksTaskIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateTaskApiV1TasksTaskIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateTaskApiV1TasksTaskIdPatchResponses, UpdateTaskApiV1TasksTaskIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{task_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tags
 */
export const listTagsApiV1TagsGet = <ThrowOnError extends boolean = false>(options?: Options<ListTagsApiV1TagsGetData, ThrowOnError>) => (options?.client ?? client).get<ListTagsApiV1TagsGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tags',
    ...options
});

/**
 * Create Tag
 */
export const createTagApiV1TagsPost = <ThrowOnError extends boolean = false>(options: Options<CreateTagApiV1TagsPostData, ThrowOnError>) => (options.client ?? client).post<CreateTagApiV1TagsPostResponses, CreateTagApiV1TagsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Tag
 */
export const deleteTagApiV1TagsTagIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteTagApiV1TagsTagIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteTagApiV1TagsTagIdDeleteResponses, DeleteTagApiV1TagsTagIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tags/{tag_id}',
    ...options
});

/**
 * Update Tag
 */
export const updateTagApiV1TagsTagIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateTagApiV1TagsTagIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateTagApiV1TagsTagIdPatchResponses, UpdateTagApiV1TagsTagIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tags/{tag_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Tag From Case
 */
export const removeTagFromCaseApiV1CasesCaseIdTagsTagIdDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveTagFromCaseApiV1CasesCaseIdTagsTagIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<RemoveTagFromCaseApiV1CasesCaseIdTagsTagIdDeleteResponses, RemoveTagFromCaseApiV1CasesCaseIdTagsTagIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/tags/{tag_id}',
    ...options
});

/**
 * Add Tag To Case
 */
export const addTagToCaseApiV1CasesCaseIdTagsTagIdPost = <ThrowOnError extends boolean = false>(options: Options<AddTagToCaseApiV1CasesCaseIdTagsTagIdPostData, ThrowOnError>) => (options.client ?? client).post<AddTagToCaseApiV1CasesCaseIdTagsTagIdPostResponses, AddTagToCaseApiV1CasesCaseIdTagsTagIdPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/tags/{tag_id}',
    ...options
});

/**
 * Get Case Tags
 */
export const getCaseTagsApiV1CasesCaseIdTagsGet = <ThrowOnError extends boolean = false>(options: Options<GetCaseTagsApiV1CasesCaseIdTagsGetData, ThrowOnError>) => (options.client ?? client).get<GetCaseTagsApiV1CasesCaseIdTagsGetResponses, GetCaseTagsApiV1CasesCaseIdTagsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/tags',
    ...options
});

/**
 * List Time Sessions
 */
export const listTimeSessionsApiV1CasesCaseIdSessionsGet = <ThrowOnError extends boolean = false>(options: Options<ListTimeSessionsApiV1CasesCaseIdSessionsGetData, ThrowOnError>) => (options.client ?? client).get<ListTimeSessionsApiV1CasesCaseIdSessionsGetResponses, ListTimeSessionsApiV1CasesCaseIdSessionsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/sessions',
    ...options
});

/**
 * Create Time Session
 */
export const createTimeSessionApiV1CasesCaseIdSessionsPost = <ThrowOnError extends boolean = false>(options: Options<CreateTimeSessionApiV1CasesCaseIdSessionsPostData, ThrowOnError>) => (options.client ?? client).post<CreateTimeSessionApiV1CasesCaseIdSessionsPostResponses, CreateTimeSessionApiV1CasesCaseIdSessionsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Time Session
 */
export const updateTimeSessionApiV1SessionsSessionIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateTimeSessionApiV1SessionsSessionIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateTimeSessionApiV1SessionsSessionIdPatchResponses, UpdateTimeSessionApiV1SessionsSessionIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sessions/{session_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Case Costs
 */
export const listCaseCostsApiV1CasesCaseIdCostsGet = <ThrowOnError extends boolean = false>(options: Options<ListCaseCostsApiV1CasesCaseIdCostsGetData, ThrowOnError>) => (options.client ?? client).get<ListCaseCostsApiV1CasesCaseIdCostsGetResponses, ListCaseCostsApiV1CasesCaseIdCostsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/costs',
    ...options
});

/**
 * Create Case Cost
 */
export const createCaseCostApiV1CasesCaseIdCostsPost = <ThrowOnError extends boolean = false>(options: Options<CreateCaseCostApiV1CasesCaseIdCostsPostData, ThrowOnError>) => (options.client ?? client).post<CreateCaseCostApiV1CasesCaseIdCostsPostResponses, CreateCaseCostApiV1CasesCaseIdCostsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/costs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Invoices
 */
export const listInvoicesApiV1CasesCaseIdInvoicesGet = <ThrowOnError extends boolean = false>(options: Options<ListInvoicesApiV1CasesCaseIdInvoicesGetData, ThrowOnError>) => (options.client ?? client).get<ListInvoicesApiV1CasesCaseIdInvoicesGetResponses, ListInvoicesApiV1CasesCaseIdInvoicesGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/invoices',
    ...options
});

/**
 * Create Invoice
 */
export const createInvoiceApiV1CasesCaseIdInvoicesPost = <ThrowOnError extends boolean = false>(options: Options<CreateInvoiceApiV1CasesCaseIdInvoicesPostData, ThrowOnError>) => (options.client ?? client).post<CreateInvoiceApiV1CasesCaseIdInvoicesPostResponses, CreateInvoiceApiV1CasesCaseIdInvoicesPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Invoice
 */
export const getInvoiceApiV1InvoicesInvoiceIdGet = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceApiV1InvoicesInvoiceIdGetData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceApiV1InvoicesInvoiceIdGetResponses, GetInvoiceApiV1InvoicesInvoiceIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invoices/{invoice_id}',
    ...options
});

/**
 * Update Invoice
 */
export const updateInvoiceApiV1InvoicesInvoiceIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceApiV1InvoicesInvoiceIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateInvoiceApiV1InvoicesInvoiceIdPatchResponses, UpdateInvoiceApiV1InvoicesInvoiceIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invoices/{invoice_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Reports
 */
export const listReportsApiV1CasesCaseIdReportsGet = <ThrowOnError extends boolean = false>(options: Options<ListReportsApiV1CasesCaseIdReportsGetData, ThrowOnError>) => (options.client ?? client).get<ListReportsApiV1CasesCaseIdReportsGetResponses, ListReportsApiV1CasesCaseIdReportsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/reports',
    ...options
});

/**
 * Create Report
 */
export const createReportApiV1CasesCaseIdReportsPost = <ThrowOnError extends boolean = false>(options: Options<CreateReportApiV1CasesCaseIdReportsPostData, ThrowOnError>) => (options.client ?? client).post<CreateReportApiV1CasesCaseIdReportsPostResponses, CreateReportApiV1CasesCaseIdReportsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Report
 */
export const getReportApiV1ReportsReportIdGet = <ThrowOnError extends boolean = false>(options: Options<GetReportApiV1ReportsReportIdGetData, ThrowOnError>) => (options.client ?? client).get<GetReportApiV1ReportsReportIdGetResponses, GetReportApiV1ReportsReportIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}',
    ...options
});

/**
 * Update Report
 */
export const updateReportApiV1ReportsReportIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateReportApiV1ReportsReportIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateReportApiV1ReportsReportIdPatchResponses, UpdateReportApiV1ReportsReportIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Report Payload
 *
 * Re-freeze the report's JSON payload + re-sign.
 *
 * Use after late-breaking evidence changes (supersedes, backfills,
 * manual corrections) so the Action Tracker and HTML viewer pick up
 * the new findings without forcing a status-flip dance.
 *
 * IMPLICATIONS
 * ============
 * - `payload_signature` and `payload_content_hash` change. Any prior
 * `/verify/{case_number}/{report_id}` URLs that pinned the *old*
 * hash will now report mismatch. Share tokens reference the report
 * by id, not by hash, so they keep working but resolve to the new
 * payload.
 * - Audit log records the refresh as a payload update.
 */
export const refreshReportPayloadApiV1ReportsReportIdRefreshPayloadPost = <ThrowOnError extends boolean = false>(options: Options<RefreshReportPayloadApiV1ReportsReportIdRefreshPayloadPostData, ThrowOnError>) => (options.client ?? client).post<RefreshReportPayloadApiV1ReportsReportIdRefreshPayloadPostResponses, RefreshReportPayloadApiV1ReportsReportIdRefreshPayloadPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/refresh-payload',
    ...options
});

/**
 * Get Exec Summary
 *
 * Return the current (possibly unapproved) executive-summary draft.
 */
export const getExecSummaryApiV1ReportsReportIdExecSummaryGet = <ThrowOnError extends boolean = false>(options: Options<GetExecSummaryApiV1ReportsReportIdExecSummaryGetData, ThrowOnError>) => (options.client ?? client).get<GetExecSummaryApiV1ReportsReportIdExecSummaryGetResponses, GetExecSummaryApiV1ReportsReportIdExecSummaryGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/exec-summary',
    ...options
});

/**
 * Update Exec Summary
 *
 * Save edits to the executive-summary draft.
 *
 * Saving a new edit clears any existing approval — the investigator must
 * re-approve after editing. This keeps the approval signal honest: an
 * approved summary is always what the approver actually read.
 */
export const updateExecSummaryApiV1ReportsReportIdExecSummaryPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateExecSummaryApiV1ReportsReportIdExecSummaryPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateExecSummaryApiV1ReportsReportIdExecSummaryPatchResponses, UpdateExecSummaryApiV1ReportsReportIdExecSummaryPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/exec-summary',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Exec Summary
 *
 * Draft an executive summary via Claude Sonnet 4.6 and save it as the
 * current (unapproved) draft.
 *
 * Generating overwrites any unapproved draft. An approved summary is
 * preserved — if the user wants to replace an approved summary, they
 * must un-approve first (PATCH the content to a new value).
 */
export const generateExecSummaryApiV1ReportsReportIdExecSummaryGeneratePost = <ThrowOnError extends boolean = false>(options: Options<GenerateExecSummaryApiV1ReportsReportIdExecSummaryGeneratePostData, ThrowOnError>) => (options.client ?? client).post<GenerateExecSummaryApiV1ReportsReportIdExecSummaryGeneratePostResponses, GenerateExecSummaryApiV1ReportsReportIdExecSummaryGeneratePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/exec-summary/generate',
    ...options
});

/**
 * Approve Exec Summary
 *
 * Mark the current draft as approved for delivery.
 *
 * Stamps approver + timestamp. PDF rendering then uses this approved copy
 * in place of the template-generated default paragraph.
 */
export const approveExecSummaryApiV1ReportsReportIdExecSummaryApprovePost = <ThrowOnError extends boolean = false>(options: Options<ApproveExecSummaryApiV1ReportsReportIdExecSummaryApprovePostData, ThrowOnError>) => (options.client ?? client).post<ApproveExecSummaryApiV1ReportsReportIdExecSummaryApprovePostResponses, ApproveExecSummaryApiV1ReportsReportIdExecSummaryApprovePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/exec-summary/approve',
    ...options
});

/**
 * Get Action Plan
 *
 * Return the current (possibly unapproved) action-plan draft.
 */
export const getActionPlanApiV1ReportsReportIdActionPlanGet = <ThrowOnError extends boolean = false>(options: Options<GetActionPlanApiV1ReportsReportIdActionPlanGetData, ThrowOnError>) => (options.client ?? client).get<GetActionPlanApiV1ReportsReportIdActionPlanGetResponses, GetActionPlanApiV1ReportsReportIdActionPlanGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/action-plan',
    ...options
});

/**
 * Update Action Plan
 *
 * Save edits to the action-plan draft; clears any existing approval.
 */
export const updateActionPlanApiV1ReportsReportIdActionPlanPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateActionPlanApiV1ReportsReportIdActionPlanPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateActionPlanApiV1ReportsReportIdActionPlanPatchResponses, UpdateActionPlanApiV1ReportsReportIdActionPlanPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/action-plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Action Plan
 *
 * Draft a strategic remediation plan via Claude Sonnet 4.6.
 *
 * Overwrites any unapproved draft; clears approval if present.
 */
export const generateActionPlanApiV1ReportsReportIdActionPlanGeneratePost = <ThrowOnError extends boolean = false>(options: Options<GenerateActionPlanApiV1ReportsReportIdActionPlanGeneratePostData, ThrowOnError>) => (options.client ?? client).post<GenerateActionPlanApiV1ReportsReportIdActionPlanGeneratePostResponses, GenerateActionPlanApiV1ReportsReportIdActionPlanGeneratePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/action-plan/generate',
    ...options
});

/**
 * Prepare Deliverables
 *
 * Generate both AI deliverables (exec summary + action plan) in parallel.
 *
 * Replaces the four-click sequence (Generate Summary → Approve → Generate
 * Plan → Approve) with one operation that drafts both at once. Drafts
 * return unapproved — the investigator still reviews and approves each
 * before downloading the final bundle. Same Anthropic API; parallel calls
 * cut wait time roughly in half (~10s end-to-end vs ~20s sequential).
 *
 * Both drafts overwrite any prior unapproved drafts. Approved drafts are
 * NOT overwritten — to replace an approved draft, edit it (which clears
 * approval) and call this endpoint again.
 */
export const prepareDeliverablesApiV1ReportsReportIdPrepareDeliverablesPost = <ThrowOnError extends boolean = false>(options: Options<PrepareDeliverablesApiV1ReportsReportIdPrepareDeliverablesPostData, ThrowOnError>) => (options.client ?? client).post<PrepareDeliverablesApiV1ReportsReportIdPrepareDeliverablesPostResponses, PrepareDeliverablesApiV1ReportsReportIdPrepareDeliverablesPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/prepare-deliverables',
    ...options
});

/**
 * Approve Action Plan
 *
 * Mark the current action-plan draft as approved for delivery.
 */
export const approveActionPlanApiV1ReportsReportIdActionPlanApprovePost = <ThrowOnError extends boolean = false>(options: Options<ApproveActionPlanApiV1ReportsReportIdActionPlanApprovePostData, ThrowOnError>) => (options.client ?? client).post<ApproveActionPlanApiV1ReportsReportIdActionPlanApprovePostResponses, ApproveActionPlanApiV1ReportsReportIdActionPlanApprovePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/action-plan/approve',
    ...options
});

/**
 * Preview Report Html
 *
 * Render the report as HTML for in-browser preview.
 *
 * Same rendering pipeline as the PDF endpoint — this is the fastest
 * iteration loop for tweaking templates and also works as a fallback
 * when WeasyPrint isn't available (user prints to PDF from the browser).
 */
export const previewReportHtmlApiV1ReportsReportIdHtmlGet = <ThrowOnError extends boolean = false>(options: Options<PreviewReportHtmlApiV1ReportsReportIdHtmlGetData, ThrowOnError>) => (options.client ?? client).get<PreviewReportHtmlApiV1ReportsReportIdHtmlGetResponses, PreviewReportHtmlApiV1ReportsReportIdHtmlGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/html',
    ...options
});

/**
 * Preview Anonymized Report
 *
 * Render the report as a sanitized marketing sample.
 *
 * Buyer identifiers (client name, target domains, contact info, case
 * number) are replaced with stable plausible placeholders. The
 * rendered HTML carries a 'SAMPLE — ANONYMIZED' watermark so it
 * cannot be confused with the original signed deliverable.
 *
 * Use case: publish as a publicly-shareable example of the report
 * format without exposing the buyer's identity. The original signed
 * report remains untouched.
 */
export const previewAnonymizedReportApiV1ReportsReportIdAnonymizedHtmlGet = <ThrowOnError extends boolean = false>(options: Options<PreviewAnonymizedReportApiV1ReportsReportIdAnonymizedHtmlGetData, ThrowOnError>) => (options.client ?? client).get<PreviewAnonymizedReportApiV1ReportsReportIdAnonymizedHtmlGetResponses, PreviewAnonymizedReportApiV1ReportsReportIdAnonymizedHtmlGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/anonymized.html',
    ...options
});

/**
 * Download Anonymized Report Pdf
 *
 * Download the anonymized report as a PDF.
 *
 * Same anonymization pipeline as the HTML endpoint, then routed
 * through Playwright for PDF rendering. The SAMPLE — ANONYMIZED
 * watermark from base.html appears on every page; the running
 * header carries 'Anonymized Sample Report' instead of the real
 * report title so screenshots / accidental shares are immediately
 * self-labeling.
 */
export const downloadAnonymizedReportPdfApiV1ReportsReportIdAnonymizedPdfGet = <ThrowOnError extends boolean = false>(options: Options<DownloadAnonymizedReportPdfApiV1ReportsReportIdAnonymizedPdfGetData, ThrowOnError>) => (options.client ?? client).get<DownloadAnonymizedReportPdfApiV1ReportsReportIdAnonymizedPdfGetResponses, DownloadAnonymizedReportPdfApiV1ReportsReportIdAnonymizedPdfGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/anonymized.pdf',
    ...options
});

/**
 * Download Report Pdf
 *
 * Render the report as a PDF via headless Chromium (Playwright).
 *
 * Chromium's print engine supports the subset of print CSS we use (@page
 * size/margin, page-break-before, SVG, CSS custom properties). Headers
 * and footers — which Chromium's @page at-rules don't support — are
 * injected via Playwright's displayHeaderFooter + header/footerTemplate.
 */
export const downloadReportPdfApiV1ReportsReportIdPdfGet = <ThrowOnError extends boolean = false>(options: Options<DownloadReportPdfApiV1ReportsReportIdPdfGetData, ThrowOnError>) => (options.client ?? client).get<DownloadReportPdfApiV1ReportsReportIdPdfGetResponses, DownloadReportPdfApiV1ReportsReportIdPdfGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/pdf',
    ...options
});

/**
 * Download Snapshot Pdf
 *
 * One-page executive snapshot: posture grade + severity + top priorities.
 *
 * Designed to be shareable with leadership / posted in Slack. Uses the same
 * render context as the main report, but a single-page Jinja template with
 * no page header/footer (the snapshot IS the page).
 */
export const downloadSnapshotPdfApiV1ReportsReportIdSnapshotPdfGet = <ThrowOnError extends boolean = false>(options: Options<DownloadSnapshotPdfApiV1ReportsReportIdSnapshotPdfGetData, ThrowOnError>) => (options.client ?? client).get<DownloadSnapshotPdfApiV1ReportsReportIdSnapshotPdfGetResponses, DownloadSnapshotPdfApiV1ReportsReportIdSnapshotPdfGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/snapshot.pdf',
    ...options
});

/**
 * Download Attestation Pdf
 *
 * Formal one-page letter of assessment.
 *
 * Client can share this with partners, insurers, or prospects as evidence
 * that an independent third-party external assessment was conducted.
 * Arm's-length language — assessment scope, assessor credentials, and
 * explicit NOT-a-certification disclaimer.
 */
export const downloadAttestationPdfApiV1ReportsReportIdAttestationPdfGet = <ThrowOnError extends boolean = false>(options: Options<DownloadAttestationPdfApiV1ReportsReportIdAttestationPdfGetData, ThrowOnError>) => (options.client ?? client).get<DownloadAttestationPdfApiV1ReportsReportIdAttestationPdfGetResponses, DownloadAttestationPdfApiV1ReportsReportIdAttestationPdfGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/attestation.pdf',
    ...options
});

/**
 * Download Deliverable Bundle
 *
 * Assemble the full client deliverable bundle as a single ZIP.
 *
 * Every engagement ships the same 3-piece bundle:
 * - Main Report PDF (comprehensive — Posture at a Glance is now the
 * opening of this document, replacing the old standalone Snapshot)
 * - Attestation Letter PDF (compliance currency)
 * - Tracking Sheet CSV (remediation management)
 *
 * This is what you send to the client. One download, one email attachment,
 * one portal upload — the three files travel together.
 */
export const downloadDeliverableBundleApiV1ReportsReportIdBundleZipGet = <ThrowOnError extends boolean = false>(options: Options<DownloadDeliverableBundleApiV1ReportsReportIdBundleZipGetData, ThrowOnError>) => (options.client ?? client).get<DownloadDeliverableBundleApiV1ReportsReportIdBundleZipGetResponses, DownloadDeliverableBundleApiV1ReportsReportIdBundleZipGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/bundle.zip',
    ...options
});

/**
 * Download Tracking Sheet Csv
 *
 * CSV/spreadsheet export of the approved action plan's line items.
 *
 * Columns: Workstream | Action | Typical Owner Role | Execution Notes |
 * Effort | Verification | Priority | Status | Target Date | Notes.
 *
 * Status / Target Date / Notes are intentionally blank for the client to
 * fill in. Can be imported into Excel, Google Sheets, Jira, Asana, etc.
 */
export const downloadTrackingSheetCsvApiV1ReportsReportIdTrackingSheetCsvGet = <ThrowOnError extends boolean = false>(options: Options<DownloadTrackingSheetCsvApiV1ReportsReportIdTrackingSheetCsvGetData, ThrowOnError>) => (options.client ?? client).get<DownloadTrackingSheetCsvApiV1ReportsReportIdTrackingSheetCsvGetResponses, DownloadTrackingSheetCsvApiV1ReportsReportIdTrackingSheetCsvGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/reports/{report_id}/tracking-sheet.csv',
    ...options
});

/**
 * List Settings
 */
export const listSettingsApiV1SettingsGet = <ThrowOnError extends boolean = false>(options?: Options<ListSettingsApiV1SettingsGetData, ThrowOnError>) => (options?.client ?? client).get<ListSettingsApiV1SettingsGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settings',
    ...options
});

/**
 * Create Setting
 */
export const createSettingApiV1SettingsPost = <ThrowOnError extends boolean = false>(options: Options<CreateSettingApiV1SettingsPostData, ThrowOnError>) => (options.client ?? client).post<CreateSettingApiV1SettingsPostResponses, CreateSettingApiV1SettingsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Setting
 */
export const deleteSettingApiV1SettingsSettingIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteSettingApiV1SettingsSettingIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteSettingApiV1SettingsSettingIdDeleteResponses, DeleteSettingApiV1SettingsSettingIdDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settings/{setting_id}',
    ...options
});

/**
 * Update Setting
 */
export const updateSettingApiV1SettingsSettingIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingApiV1SettingsSettingIdPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateSettingApiV1SettingsSettingIdPatchResponses, UpdateSettingApiV1SettingsSettingIdPatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/settings/{setting_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Dashboard Stats
 */
export const getDashboardStatsApiV1DashboardStatsGet = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardStatsApiV1DashboardStatsGetData, ThrowOnError>) => (options?.client ?? client).get<GetDashboardStatsApiV1DashboardStatsGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboard/stats',
    ...options
});

/**
 * Trigger Tool Run
 *
 * Trigger a tool run against a target. Creates in 'queued' status,
 * fires execution as a FastAPI BackgroundTask, and returns immediately.
 *
 * The HTTP response comes back as soon as the row is created, NOT
 * when the tool finishes. The frontend polls /cases/{id}/tool-runs
 * every 3s to surface progress; the queued row appears in the
 * progress strip immediately, transitions to 'running' when the bg
 * task picks it up, then to 'complete' or 'failed' when the executor
 * finishes.
 *
 * Rejects the request if the same tool is already queued or running
 * against this target — prevents accidental duplicate execution from
 * double-clicks or navigating-back-and-clicking-again.
 */
export const triggerToolRunApiV1ToolsRunPost = <ThrowOnError extends boolean = false>(options: Options<TriggerToolRunApiV1ToolsRunPostData, ThrowOnError>) => (options.client ?? client).post<TriggerToolRunApiV1ToolsRunPostResponses, TriggerToolRunApiV1ToolsRunPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tools/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tool Runs
 */
export const listToolRunsApiV1CasesCaseIdToolRunsGet = <ThrowOnError extends boolean = false>(options: Options<ListToolRunsApiV1CasesCaseIdToolRunsGetData, ThrowOnError>) => (options.client ?? client).get<ListToolRunsApiV1CasesCaseIdToolRunsGetResponses, ListToolRunsApiV1CasesCaseIdToolRunsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/tool-runs',
    ...options
});

/**
 * Get Tool Run
 */
export const getToolRunApiV1ToolRunsToolRunIdGet = <ThrowOnError extends boolean = false>(options: Options<GetToolRunApiV1ToolRunsToolRunIdGetData, ThrowOnError>) => (options.client ?? client).get<GetToolRunApiV1ToolRunsToolRunIdGetResponses, GetToolRunApiV1ToolRunsToolRunIdGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tool-runs/{tool_run_id}',
    ...options
});

/**
 * Cancel Tool Run
 */
export const cancelToolRunApiV1ToolRunsToolRunIdCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelToolRunApiV1ToolRunsToolRunIdCancelPostData, ThrowOnError>) => (options.client ?? client).post<CancelToolRunApiV1ToolRunsToolRunIdCancelPostResponses, CancelToolRunApiV1ToolRunsToolRunIdCancelPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tool-runs/{tool_run_id}/cancel',
    ...options
});

/**
 * Get Tool Run Raw Output
 *
 * Return the persisted raw stdout/stderr/exit_code diagnostic for a
 * tool run, captured by run_tool_command's chain-of-custody helper.
 *
 * Path-traversal safety: the file at tool_run.raw_output_url must
 * resolve to a real file under Settings.tool_run_output_path. Any
 * path outside that directory rejects with 404. This guards against
 * a malformed/poisoned raw_output_url leaking arbitrary host files.
 *
 * Size cap: 5 MiB. Tool outputs that legitimately exceed this are
 * truncated with a marker line; the on-disk file remains intact for
 * a manual inspection if needed.
 */
export const getToolRunRawOutputApiV1ToolRunsToolRunIdRawOutputGet = <ThrowOnError extends boolean = false>(options: Options<GetToolRunRawOutputApiV1ToolRunsToolRunIdRawOutputGetData, ThrowOnError>) => (options.client ?? client).get<GetToolRunRawOutputApiV1ToolRunsToolRunIdRawOutputGetResponses, GetToolRunRawOutputApiV1ToolRunsToolRunIdRawOutputGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tool-runs/{tool_run_id}/raw-output',
    ...options
});

/**
 * Execute Next Scan Step
 *
 * Execute the next pending scan plan step(s) matching a task title.
 *
 * Finds all pending steps whose tool_name matches the task title pattern
 * (e.g., "Run Subdomain Enumeration" maps to subfinder, theHarvester)
 * and runs them sequentially. Returns results.
 *
 * This is the production-safe pattern: one task = one logical group of
 * related tool runs, executed sequentially with status tracking.
 */
export const executeNextScanStepApiV1CasesCaseIdScanPlanExecuteNextPost = <ThrowOnError extends boolean = false>(options: Options<ExecuteNextScanStepApiV1CasesCaseIdScanPlanExecuteNextPostData, ThrowOnError>) => (options.client ?? client).post<ExecuteNextScanStepApiV1CasesCaseIdScanPlanExecuteNextPostResponses, ExecuteNextScanStepApiV1CasesCaseIdScanPlanExecuteNextPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/scan-plan/execute-next',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Scan All Pending For Target
 *
 * Queue every applicable-but-not-yet-run tool for a single target.
 *
 * Complements the case-level execute-all endpoint. Useful when:
 * - new targets are added AFTER the scan plan was generated (the plan
 * has no steps for them)
 * - a specific target needs re-scanning after remediation
 * - the investigator wants to fill in tool-level gaps without touching
 * other targets
 *
 * Logic:
 * 1. Load the target + its case
 * 2. Determine which tools are compatible with the target type and
 * serve modules enabled in engagement_config (or all if no config)
 * 3. Skip tools flagged subdomain_skip when the target is a subdomain
 * — most root-domain queries (DMARC, WHOIS, brand searches, breach
 * indices, etc.) produce identical or empty results on a subdomain
 * 4. For each applicable tool, skip if a queued/running/complete run
 * already exists on this target
 * 5. Background-execute whatever's left
 */
export const scanAllPendingForTargetApiV1TargetsTargetIdScanAllPendingPost = <ThrowOnError extends boolean = false>(options: Options<ScanAllPendingForTargetApiV1TargetsTargetIdScanAllPendingPostData, ThrowOnError>) => (options.client ?? client).post<ScanAllPendingForTargetApiV1TargetsTargetIdScanAllPendingPostResponses, ScanAllPendingForTargetApiV1TargetsTargetIdScanAllPendingPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/targets/{target_id}/scan-all-pending',
    ...options
});

/**
 * Execute All Pending Steps
 *
 * Queue and execute ALL pending scan plan steps in one click.
 *
 * Finds every step with status='pending' in the scan plan, queues them,
 * and kicks off a background task that runs them sequentially. Returns
 * immediately with the number of steps queued — the UI polls tool-runs
 * to watch progress.
 *
 * Skips steps that already have a queued or running tool_run for the
 * same target + tool (the idempotency check from POST /tools/run).
 */
export const executeAllPendingStepsApiV1CasesCaseIdScanPlanExecuteAllPost = <ThrowOnError extends boolean = false>(options: Options<ExecuteAllPendingStepsApiV1CasesCaseIdScanPlanExecuteAllPostData, ThrowOnError>) => (options.client ?? client).post<ExecuteAllPendingStepsApiV1CasesCaseIdScanPlanExecuteAllPostResponses, ExecuteAllPendingStepsApiV1CasesCaseIdScanPlanExecuteAllPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/scan-plan/execute-all',
    ...options
});

/**
 * Get Scan Plan
 *
 * Get the scan plan for a case, if one exists.
 */
export const getScanPlanApiV1CasesCaseIdScanPlanGet = <ThrowOnError extends boolean = false>(options: Options<GetScanPlanApiV1CasesCaseIdScanPlanGetData, ThrowOnError>) => (options.client ?? client).get<GetScanPlanApiV1CasesCaseIdScanPlanGetResponses, GetScanPlanApiV1CasesCaseIdScanPlanGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/scan-plan',
    ...options
});

/**
 * Get Scan Progress
 *
 * Aggregate scan progress for a case using *distinct (tool, target) pairs*.
 *
 * The previous implementation counted raw `tool_run` rows, which broke
 * in two ways the operator hit on the Tavaci engagement (2026-06-26):
 * 1. Re-running the same (tool, target) added to the numerator
 * without changing the denominator — so an engagement where the
 * operator iterated on nmap five times showed 230% complete.
 * 2. Targets added AFTER the scan plan was generated didn't update
 * the denominator (the plan is frozen at generation time), so
 * new-target runs pushed the bar past 100% even without re-runs.
 *
 * The new math counts each (tool_name, target_id) pair at most once:
 * - `planned`  = current desired set = TOOL_DEFS × in-scope, non-
 * suggestion targets, filtered by engagement_config
 * modules + subdomain_skip. Recomputed on each call
 * so new targets immediately update the denominator.
 * - `complete` = count of distinct (tool, target) pairs with at
 * least one COMPLETE run.
 * - `failed`   = count of distinct (tool, target) pairs whose runs
 * have all failed (no complete sibling).
 * - `percent`  = complete / planned, capped at 100%. The
 * interpretation is "how much of the work I want done
 * is done" — re-runs and new targets don't inflate.
 *
 * The status-chip fields (`queued`, `running`, `cancelled`, `enrolled`)
 * keep their raw `tool_run` row counts because they represent active
 * work in flight RIGHT NOW, not unique work definitions.
 *
 * Response shape (compatibility with the frontend ScanProgressStrip
 * preserved — same keys, corrected semantics):
 * {
 * "planned": 130,    // unique (tool, target) pairs for current
 * // in-scope targets via TOOL_DEFS
 * "enrolled": 99,    // raw tool_run row count
 * "queued": 0,
 * "running": 0,
 * "complete": 92,    // distinct pairs with ≥1 complete run
 * "failed": 7,       // distinct pairs whose runs all failed
 * "cancelled": 0,
 * "percent": 70,     // complete / planned, capped at 100
 * "has_plan": true,
 * }
 */
export const getScanProgressApiV1CasesCaseIdScanProgressGet = <ThrowOnError extends boolean = false>(options: Options<GetScanProgressApiV1CasesCaseIdScanProgressGetData, ThrowOnError>) => (options.client ?? client).get<GetScanProgressApiV1CasesCaseIdScanProgressGetResponses, GetScanProgressApiV1CasesCaseIdScanProgressGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/scan-progress',
    ...options
});

/**
 * Stream Scan Events
 *
 * Server-Sent Events stream of live scan transitions on a case.
 *
 * Operative subscribes once per case-detail page open and consumes:
 * - `tool_run.transitioned` — queued → running → complete/failed
 * - `evidence_card.created` — new finding inserted under this case
 * - `scan_plan.complete`   — every step in the plan finished
 * - `dropped`              — back-pressure notification when the
 * per-subscriber queue overflowed
 *
 * Replaces the 3-second polling pattern (`useQuery({refetchInterval:
 * 3000})`) on the tool-runs + scan-progress views. Events arrive in
 * milliseconds; the UI re-fetches authoritative state on each event
 * rather than rendering the event payload directly — this keeps the
 * SSE layer thin and means a missed event during reconnection only
 * delays the next visible state change by the time-until-next-event,
 * not until-next-poll.
 *
 * The handler holds the connection open until the client disconnects.
 * A 15-second keepalive comment (`: keepalive\n\n`) prevents
 * intermediate proxies from closing idle connections.
 */
export const streamScanEventsApiV1CasesCaseIdScanEventsGet = <ThrowOnError extends boolean = false>(options: Options<StreamScanEventsApiV1CasesCaseIdScanEventsGetData, ThrowOnError>) => (options.client ?? client).get<StreamScanEventsApiV1CasesCaseIdScanEventsGetResponses, StreamScanEventsApiV1CasesCaseIdScanEventsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cases/{case_id}/scan-events',
    ...options
});

/**
 * List Available Tools
 *
 * List all integrated tools with their status.
 */
export const listAvailableToolsApiV1ToolsAvailableGet = <ThrowOnError extends boolean = false>(options?: Options<ListAvailableToolsApiV1ToolsAvailableGetData, ThrowOnError>) => (options?.client ?? client).get<ListAvailableToolsApiV1ToolsAvailableGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tools/available',
    ...options
});

/**
 * Get Tool Default Args
 *
 * Return the editable CLI args template for a tool.
 *
 * Powers the Operative "Run modified" dialog: the operator clicks the
 * sibling button next to "Run", this endpoint pre-fills the dialog's
 * editable text field with the tool's current DEFAULT_ARGS, the
 * operator edits, and the resulting string lands in
 * tool_run.override_args via POST /tools/run.
 *
 * For tools without a registered template (API-based local executors
 * like shodan / enzoic, or future tools missing from
 * DEFAULT_ARGS_TEMPLATES), returns supports_override=False with a
 * short note so the dialog can show a friendly "this tool's args
 * aren't editable" message rather than 404.
 *
 * Tool names are lowercase except `theHarvester` which uses its
 * canonical mixed-case spelling — matches both SSH_EXECUTORS keys
 * and DEFAULT_ARGS_TEMPLATES keys.
 */
export const getToolDefaultArgsApiV1ToolsToolNameDefaultArgsGet = <ThrowOnError extends boolean = false>(options: Options<GetToolDefaultArgsApiV1ToolsToolNameDefaultArgsGetData, ThrowOnError>) => (options.client ?? client).get<GetToolDefaultArgsApiV1ToolsToolNameDefaultArgsGetResponses, GetToolDefaultArgsApiV1ToolsToolNameDefaultArgsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tools/{tool_name}/default-args',
    ...options
});

/**
 * List Integrations
 *
 * List all configured integrations. Never includes credential values.
 */
export const listIntegrationsApiV1IntegrationsGet = <ThrowOnError extends boolean = false>(options?: Options<ListIntegrationsApiV1IntegrationsGetData, ThrowOnError>) => (options?.client ?? client).get<ListIntegrationsApiV1IntegrationsGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations',
    ...options
});

/**
 * Create Integration
 *
 * Create a new integration entry. Encrypts credentials at write time.
 */
export const createIntegrationApiV1IntegrationsPost = <ThrowOnError extends boolean = false>(options: Options<CreateIntegrationApiV1IntegrationsPostData, ThrowOnError>) => (options.client ?? client).post<CreateIntegrationApiV1IntegrationsPostResponses, CreateIntegrationApiV1IntegrationsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Integration
 *
 * Delete an integration by name.
 */
export const deleteIntegrationApiV1IntegrationsNameDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteIntegrationApiV1IntegrationsNameDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteIntegrationApiV1IntegrationsNameDeleteResponses, DeleteIntegrationApiV1IntegrationsNameDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{name}',
    ...options
});

/**
 * Get Integration
 *
 * Fetch a single integration by name. Never includes credential values.
 */
export const getIntegrationApiV1IntegrationsNameGet = <ThrowOnError extends boolean = false>(options: Options<GetIntegrationApiV1IntegrationsNameGetData, ThrowOnError>) => (options.client ?? client).get<GetIntegrationApiV1IntegrationsNameGetResponses, GetIntegrationApiV1IntegrationsNameGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{name}',
    ...options
});

/**
 * Update Integration
 *
 * Update an integration's credentials or enabled flag.
 *
 * All fields optional. Only fields present in the request body are
 * touched. To clear an existing api_secret without removing the
 * integration, send api_secret as an empty SecretStr.
 */
export const updateIntegrationApiV1IntegrationsNamePatch = <ThrowOnError extends boolean = false>(options: Options<UpdateIntegrationApiV1IntegrationsNamePatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateIntegrationApiV1IntegrationsNamePatchResponses, UpdateIntegrationApiV1IntegrationsNamePatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Integration
 *
 * Synchronously test the integration's credentials against its API.
 *
 * Looks up the credential, runs the registered per-integration tester
 * (5-second total timeout), persists the result, and returns the
 * outcome. Credentials never appear in the response or in any audit
 * log entry.
 */
export const testIntegrationApiV1IntegrationsNameTestPost = <ThrowOnError extends boolean = false>(options: Options<TestIntegrationApiV1IntegrationsNameTestPostData, ThrowOnError>) => (options.client ?? client).post<TestIntegrationApiV1IntegrationsNameTestPostResponses, TestIntegrationApiV1IntegrationsNameTestPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/integrations/{name}/test',
    ...options
});
